<template>
  <div class="hotel-form-wrapper">
    <div class="hotel-form-container">
      <div class="sticky-action-buttons">
        <div class="sticky-buttons-container px-4 md:px-0">
          <div class="flex items-center gap-2 md:gap-4 overflow-hidden">
            <vs-button type="button" @click.prevent="handleCancel"
              class="text-black bg-white font-bold cancel-btn">Cancel</vs-button>
            <span class="property-name-display truncate max-w-[150px] md:max-w-none" v-if="formData.property_name">{{
              formData.property_name }}</span>
          </div>
          <div class="flex items-center gap-2 md:gap-4">
            <vs-button type="button" id="save-draft-btn" @click.prevent="handleSaveAsDraft"
              :disabled="isPublishing || isSavingDraft" color="secondary" size="large"
              class="save-draft-btn vs-con-loading__container">
              Save as draft
            </vs-button>
            <vs-button @click.prevent="handlePublish" :disabled="isPublishing || isSavingDraft" color="primary"
              size="large" class="publish-btn vs-con-loading__container" id="submit-hotel-form-btn">
              {{ isPublishing ? 'Publishing...' : 'Publish' }}
            </vs-button>
          </div>
        </div>
      </div>

      <div class="form-content-scrollable">
        <div class="form-content">
          <form @submit.prevent="handleFormSubmit">
            <!-- Step 1: Basic Information -->
            <div class="form-section mb-8">
              <h3 class="section-title mb-0">Property Details</h3>
              <div class="vx-row">
                <!-- <div class="vx-col md:w-1/1 w-full md:mt-8">
              <div>
                <p class="text-lg font-bold">Property Type *</p>
                <div class="border border-gray-200 rounded-lg pr-4 py-4">
                  <div class="flex items-center gap-6">
                    <div
                      v-for="option in propertyTypeOptions"
                      :key="option.value"
                      :class="['property-type-card border rounded-lg  p-6 cursor-pointer selected ', isPropertyTypeSelected(option.value) ? 'selected' : '']"
                      @click="propertyTypeSelection = option.value"
                    >
                      <div class="flex items-center gap-3">
                        <vs-radio v-model="propertyTypeSelection" :vs-value="option.value" vs-name="property_type"></vs-radio>
                        <span class="font-medium text-lg">{{ option.label }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <span v-if="step1Errors.type" class="text-danger text-sm mt-2 block">{{ step1Errors.type }}</span>
              </div>
            </div>
            <vs-divider></vs-divider> -->
                <div class="vx-col md:w-1/2 w-full my-3">
                  <p class="mb-2 text-md font-bold">Property Name *</p>
                  <vs-input v-model="formData.property_name" @input="step1Errors.property_name = ''"
                    placeholder="Enter Property Name" class="w-full" />
                  <span v-if="step1Errors.property_name" class="text-danger text-sm">{{ step1Errors.property_name
                  }}</span>
                </div>

                <div class="vx-col md:w-1/2 w-full my-3" v-if="canEditHotelPlatformFee">
                  <p class="mb-2 text-md font-bold">Sangat Platform Fee *</p>
                  <percentage-input>
                    <vs-input
                      type="number"
                      min="0"
                      :max="99"
                      step="0.01"
                      v-model.number="formData.platform_fee"
                      class="w-full"
                      placeholder="0"
                      @input="handlePlatformFeeInput"
                    />
                  </percentage-input>
                  <span v-if="step1Errors.platform_fee" class="text-danger text-sm">{{ step1Errors.platform_fee
                  }}</span>
                </div>

                <div class="vx-col w-full mb-4 mt-4">
                  <p class="mb-2 text-md font-bold">Property Images *</p>

                  <div class="file-upload-wrapper">
                    <label for="property-images-upload" class="file-upload-box w-full md:max-w-md">
                      <input id="property-images-upload" :key="fileKey" type="file" class="file-input-hidden"
                        accept=".jpg, .png, .jpeg" @change="handleFileUpload" multiple />
                      <div class="file-upload-content-new">
                        <feather-icon icon="UploadIcon" :svgClasses="['w-6', 'h-6', 'text-black']" />
                        <span class="file-upload-text-new">Browse files to upload image</span>
                      </div>
                    </label>
                  </div>

                  <div class="file-upload-note">
                    <p class="file-upload-note-text">Please note - Only 20 images can be uploaded. File size should be
                      less than 1 MB. Only PNG and JPG format is supported.</p>
                  </div>

                  <span v-if="step1Errors.images" class="text-danger text-sm mt-2 block">{{ step1Errors.images }}</span>

                  <div class="mt-4 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4"
                    v-if="formData.images && formData.images.length > 0">
                    <div v-for="(image, index) in formData.images" :key="index" class="relative aspect-square">
                      <img :src="image" alt="Preview" class="w-full h-full object-cover rounded-lg shadow-sm" />
                      <button type="button" @click="removeImage(index)" class="remove-image-btn">
                        <feather-icon icon="XIcon" :svgClasses="['w-4', 'h-4']" />
                      </button>
                    </div>
                  </div>
                </div>

                <div class="vx-col w-full mt-3">
                  <div class="demo-alignment">
                    <p class="mb-2 text-md font-bold">Property Description *</p>
                    <vs-textarea v-model="formData.description" placeholder="Write brief about the property"
                      height="150px" />
                    <span v-if="step1Errors.description" class="text-danger text-sm">{{ step1Errors.description
                    }}</span>
                  </div>
                </div>

                <!-- Amenities Section -->
                <vs-divider></vs-divider>
                <div class="vx-col w-full my-5 mb-8">
                  <h3 class="text-xl font-bold">Amenities Details</h3>
                  <div class="amenities-container vx-row mt-4">
                    <div class="vx-col md:w-1/6 w-1/2 mb-4">
                      <label class="vs-input--label">Free Wifi</label>
                      <vs-switch color="success" class="mt-2" v-model="formData.free_wifi" />
                    </div>
                    <div class="vx-col md:w-1/6 w-1/2 mb-4">
                      <label class="vs-input--label">Parking</label>
                      <vs-switch color="success" class="mt-2" v-model="formData.parking" />
                    </div>
                  </div>
                </div>

                <vs-divider></vs-divider>
                <!-- Opening Hours Section -->
                <div class="vx-col w-full mt-5 mb-8">
                  <div class="flex items-center justify-between mt-2">
                    <h3 class="text-xl font-bold my-5">Opening Hours</h3>
                    <div class="flex items-center gap-4">
                      <vs-switch v-model="formData.is24hOpen" @change="handle24hToggle" color="success" />
                      <strong class="vs-input--label">Open All Day (24/7)</strong>
                    </div>
                  </div>

                  <div class="vx-row mt-4 mb-4 font-bold hidden md:flex">
                    <div class="vx-col w-1/4">Day</div>
                    <div class="vx-col w-1/4">Open Time</div>
                    <div class="vx-col w-1/4">Close Time</div>
                    <div class="vx-col w-1/4 text-center"></div>
                  </div>

                  <div v-for="(day, index) in WEEK_DAYS" :key="index" class="vx-row mb-4 items-center">
                    <div class="vx-col w-full md:w-1/4">
                      <label class="text-lg font-normal">{{ day }}</label>
                    </div>
                    <div class="vx-col w-1/2 md:w-1/4">
                      <flat-pickr :config="configdateTimePicker"
                        v-model="formData.opening_hours.find((d) => d.day === day).open_time" placeholder="Open Time"
                        class="form-control w-full mt-1"
                        @on-change="(selectedDates) => validateTime(day, selectedDates[0], 'open_time')"
                        :disabled="formData.is24hOpen" />
                    </div>
                    <div class="vx-col w-1/2 md:w-1/4">
                      <flat-pickr :config="configdateTimePicker"
                        v-model="formData.opening_hours.find((d) => d.day === day).close_time" placeholder="Close Time"
                        class="form-control w-full mt-1"
                        @on-change="(selectedDates) => validateTime(day, selectedDates[0], 'close_time')"
                        :disabled="formData.is24hOpen" />
                    </div>
                    <div class="vx-col w-full md:w-1/4 text-center mt-2 md:mt-0">
                      <div v-show="!formData.is24hOpen && lastModifiedDay === day && !step1Errors[day]">
                        <vs-button @click="copyToAllDays" color="black" type="filled" icon-pack="feather"
                          icon="icon-copy" class="w-full">
                          Copy To All Days
                        </vs-button>
                      </div>
                    </div>
                    <!-- Day Error Message -->
                    <div class="vx-col w-full" v-if="step1Errors[day]">
                      <span class="text-danger text-sm block mb-4 mt-1">{{ step1Errors[day] }}</span>
                    </div>
                  </div>
                </div>

                <vs-divider></vs-divider>

                <!-- Social Media Links Section -->
                <div class="vx-col w-full mb-8">
                  <h3 class="text-xl font-bold my-10">Social Media Links</h3>
                  <div class="vx-row mt-4">
                    <div class="vx-col md:w-1/3 w-full mb-8">
                      <vs-input class="w-full" v-model="formData.social_media.facebook" label="Facebook"
                        placeholder="https://www.facebook.com/YourPage" />
                    </div>
                    <div class="vx-col md:w-1/3 w-full mb-8">
                      <vs-input class="w-full" v-model="formData.social_media.instagram" label="Instagram"
                        placeholder="https://www.instagram.com/YourProfile" />
                    </div>
                    <div class="vx-col md:w-1/3 w-full mb-8">
                      <vs-input class="w-full" v-model="formData.social_media.twitter" label="Twitter"
                        placeholder="https://www.twitter.com/YourProfile" />
                    </div>
                    <div class="vx-col md:w-1/3 w-full mb-8">
                      <vs-input class="w-full" v-model="formData.social_media.snapchat" label="Snapchat"
                        placeholder="https://www.snapchat.com/YourProfile" />
                    </div>
                    <div class="vx-col md:w-1/3 w-full mb-8">
                      <vs-input class="w-full" v-model="formData.social_media.tiktok" label="TikTok"
                        placeholder="https://www.tiktok.com/@YourProfile" />
                    </div>
                    <div class="vx-col md:w-1/3 w-full mb-8">
                      <vs-input class="w-full" v-model="formData.social_media.linkedin" label="LinkedIn"
                        placeholder="https://www.linkedin.com/in/YourProfile" />
                    </div>
                    <div class="vx-col md:w-1/3 w-full mb-8">
                      <vs-input class="w-full" v-model="formData.social_media.youtube" label="YouTube"
                        placeholder="https://www.youtube.com/c/YourChannel" />
                    </div>
                  </div>
                </div>

                <vs-divider></vs-divider>

                <!-- Other Links Section -->
                <div class="vx-col w-full mb-8">
                  <div class="flex justify-between items-center my-5">
                    <h3 class="text-xl font-bold">Other Links</h3>
                    <vs-button @click="addOtherLink" color="primary" type="border" icon="add">Add Link</vs-button>
                  </div>
                  <div v-for="(link, index) in formData.custom_link" :key="index" class="vx-row mb-4 items-end">
                    <div class="vx-col md:w-5/12 w-full">
                      <vs-input v-model="link.title" label="Title" placeholder="Link Title" class="w-full" />
                    </div>
                    <div class="vx-col md:w-5/12 w-full">
                      <vs-input v-model="link.link" label="URL" placeholder="https://..." class="w-full" />
                    </div>
                    <div class="vx-col md:w-2/12 w-full mt-2 md:mt-0">
                      <vs-button @click="removeOtherLink(index)" color="danger" type="flat" icon-pack="feather"
                        icon="icon-trash-2" />
                    </div>
                  </div>
                </div>

                <vs-divider></vs-divider>

                <!-- Other Names Section -->
                <div class="vx-col w-full mb-8">
                  <div class="flex justify-between items-center my-5">
                    <h3 class="text-xl font-bold">Other Names</h3>
                    <vs-button @click="addData('other_name')" color="primary" type="border" icon="add">Add
                      Name</vs-button>
                  </div>
                  <div class="vx-row">
                    <div v-for="(name, index) in formData.other_name" :key="index" class="vx-col md:w-1/3 w-full mb-4">
                      <div class="flex items-center gap-2">
                        <vs-input v-model="formData.other_name[index]" placeholder="Other Name" class="w-full" />
                        <vs-button @click="removeData('other_name', index)" color="danger" type="flat"
                          icon-pack="feather" icon="icon-trash-2" />
                      </div>
                    </div>
                  </div>
                </div>

                <vs-divider></vs-divider>

                <!-- Youtube Handle Names Section -->
                <div class="vx-col w-full mb-8">
                  <div class="flex justify-between items-center my-5">
                    <h3 class="text-xl font-bold">Youtube Handle Names</h3>
                    <vs-button @click="addData('youtube_handle_name')" color="primary" type="border" icon="add">Add
                      Handle</vs-button>
                  </div>
                  <div class="vx-row">
                    <div v-for="(handle, index) in formData.youtube_handle_name" :key="index"
                      class="vx-col md:w-1/3 w-full mb-4">
                      <div class="flex items-center gap-2">
                        <vs-input v-model="formData.youtube_handle_name[index]" placeholder="@ChannelHandle"
                          class="w-full" />
                        <vs-button @click="removeData('youtube_handle_name', index)" color="danger" type="flat"
                          icon-pack="feather" icon="icon-trash-2" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Step 2: Room Management -->
            <div class="form-section mb-8">
              <div class="mb-6 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                <h3 class="room-section-title mb-0">Rooms</h3>
                <!-- Fixed Add Room Button - Top of Rooms Tab -->
                <button v-if="roomTypesList.length !== 0" @click.prevent="openRoomModal()"
                  class="add-room-fixed-btn-main m-0">
                  <span class="room-add-icon">+</span>&nbsp;&nbsp;&nbsp;Add New Room Type
                </button>
              </div>

              <!-- Room List UI -->
              <div class="mb-4 room-management-container">
                <div class="rooms-list" v-if="roomTypesList.length > 0">
                  <div v-for="(roomType, index) in roomTypesList" :key="index" class="room-type-item mb-4 lg:mr-10">
                    <!-- Room Type Header -->
                    <div class="room-type-header border  p-3 md:p-4 bg-white">
                      <div style="border-radius: 10px;"
                        class="flex flex-col lg:flex-row  lg:items-center gap-4 xl:gap-8">
                        <!-- Left Section: Toggle, Name, and User Icon -->
                        <div class="flex items-center gap-3 w-full lg:w-auto min-w-[200px]">
                          <vs-switch v-model="roomType.is_active" />
                          <h4 class="room-type-title truncate">{{ roomType.name }}{{ roomType.number_of_rooms > 1 ? `
                            (${roomType.number_of_rooms} rooms)` : '' }}</h4>
                          <feather-icon icon="UserIcon"
                            :svgClasses="['w-5', 'h-5', 'text-gray-600', 'flex-shrink-0']" />
                        </div>

                        <!-- Middle Section: Edit Room Type Link -->
                        <div class="flex-1 w-full lg:auto border-t lg:border-t-0 pt-3 lg:pt-0">
                          <a class="room-edit-link" @click="openRoomModal(roomType)">
                            <feather-icon icon="EditIcon" :svgClasses="['w-5', 'h-5']" />
                            Edit Room Type
                          </a>
                          <p class="room-item-description">Description, Photos, Pricing & Amenities</p>
                        </div>

                        <!-- Right Section: Actions and Pricing -->
                        <div
                          class="flex flex-col sm:flex-row sm:items-center gap-4 xl:gap-8 lg:flex-1 lg:justify-between w-full lg:w-auto border-t lg:border-t-0 pt-4 lg:pt-0">
                          <!-- See Options Toggle -->
                          <template v-if="roomType.options && roomType.options.length > 0">
                            <div class="cursor-pointer min-w-[100px]" @click="toggleRoomOptions(index)">
                              <a class="room-action-link room-options-toggle">
                                <feather-icon :icon="roomType.showOptions ? 'ChevronUpIcon' : 'ChevronDownIcon'"
                                  :svgClasses="['w-5', 'h-5']" />
                                {{ roomType.showOptions ? 'Hide Options' : 'See Options' }}
                              </a>
                            </div>
                          </template>

                          <!-- Price Display -->
                          <template v-else>
                            <div class="flex flex-col min-w-[100px]">
                              <p class="room-price-display">INR {{ roomType.price_per_night || 0 }}</p>
                              <p class="room-taxes-display">you will receive INR {{ roomType.net_receive ||
                                roomType.received_amount || 0 }}</p>
                            </div>
                          </template>

                          <!-- Add Option Link -->
                          <a class="room-action-link add-option-link" @click="openOptionModal(roomType)">
                            <span class="font-bold text-base">+</span> Add An Option
                          </a>

                          <!-- Actions: Duplicate & Delete -->
                          <div class="flex items-center gap-3 lg:gap-4 xl:gap-8 border-t sm:border-t-0 pt-3 sm:pt-0">
                            <a class="room-action-link duplicate-btn" @click="duplicateRoomType(roomType)">
                              <feather-icon icon="CopyIcon" :svgClasses="['w-4', 'h-4']" />
                              <span>Duplicate</span>
                            </a>
                            <a class="room-action-link delete-btn" @click="deleteRoomType(index)">
                              <feather-icon icon="TrashIcon" :svgClasses="['w-4', 'h-4']" />
                              <span>Delete</span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Room Options (Expandable) -->
                    <transition name="slide-fade">
                      <div v-if="roomType.showOptions && roomType.options && roomType.options.length > 0"
                        class="room-options-container mt-2 md:ml-20 md:mr-6 px-2 md:px-0">
                        <div v-for="(option, optIndex) in roomType.options" :key="optIndex"
                          class="room-option-item border rounded-lg p-3 md:p-4 bg-white mb-4">
                          <div class="flex flex-col md:flex-row items-start justify-between gap-4 md:gap-8">
                            <!-- Left Section: Toggle, Name, Capacity -->
                            <div class="flex items-center gap-3 w-full md:w-auto">
                              <vs-switch v-model="option.is_active" />
                              <h5 class="room-option-title truncate">{{ option.name || `Option ${optIndex + 1}` }}</h5>
                              <div class="flex gap-0.5 flex-shrink-0">
                                <feather-icon v-for="i in Math.min(option.capacity || 2, 3)" :key="i" icon="UserIcon"
                                  :svgClasses="['w-5', 'h-5', 'text-gray-600']" />
                                <span v-if="(option.capacity || 2) > 3" class="room-capacity-more">+{{ (option.capacity
                                  || 2) - 3 }}</span>
                              </div>
                            </div>

                            <!-- Middle Section: Option Details -->
                            <div class="flex-1 md:px-4 w-full md:w-auto">
                              <div class="room-option-details-container">
                                <span v-if="option.description">{{ option.description }}</span>
                              </div>
                            </div>

                            <!-- Right Section: Price & Actions -->
                            <div
                              class="flex flex-col sm:flex-row items-start sm:items-center gap-4 md:gap-10 w-full md:w-auto border-t md:border-t-0 pt-4 md:pt-0">
                              <!-- Price -->
                              <div class="flex flex-col">
                                <p class="room-price-display">INR {{ option.price || option.your_charge || 0 }}</p>
                                <p class="room-taxes-display">you will receive INR {{ option.received_amount ||
                                  option.net_receive || 0 }}
                                </p>
                              </div>

                              <!-- Actions -->
                              <div class="flex items-center gap-4 md:gap-8">
                                <a class="room-action-link" @click="openOptionModal(roomType, option)">
                                  <feather-icon icon="EditIcon" :svgClasses="['w-4', 'h-4']" />
                                  <span class="hidden sm:inline">Edit Option</span>
                                </a>
                                <a class="room-action-link" @click="duplicateRoomOption(roomType, option)">
                                  <feather-icon icon="CopyIcon" :svgClasses="['w-4', 'h-4']" />
                                  <span class="hidden sm:inline">Duplicate</span>
                                </a>
                                <a class="room-action-link" @click="deleteRoomOption(roomType, optIndex)">
                                  <feather-icon icon="TrashIcon" :svgClasses="['w-4', 'h-4']" />
                                  <span class="hidden sm:inline">Delete</span>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Add Option Button at Bottom -->
                        <button type="button" class="btn-add-option w-full md:w-auto justify-center"
                          @click="openOptionModal(roomType)"><span class="font-bold text-lg">+</span> Add An
                          Option</button>
                      </div>
                    </transition>
                  </div>
                </div>

                <div v-if="roomTypesList.length === 0" class="pt-24">
                  <div class="text-center text-lg py-8 text-gray-500">No room types added. Click "Add New Room Type" to
                    add a room.
                  </div>
                  <div class="flex items-center justify-center w-full">
                    <vs-button @click.prevent="openRoomModal()" color="primary" size="large" class="add-room-fixed-btn">
                      <feather-icon icon="PlusIcon" svgClasses="h-5 w-5" /> Add New Room Type </vs-button>
                  </div>
                </div>
              </div>

              <!-- Add/Edit Room Type Modal -->
              <vs-popup :active.sync="showRoomModal" :title="currentRoomType ? 'Edit Room Type' : 'Add Room Type'"
                class="room-type-modal">
                <!-- Sticky Action Buttons at Top -->
                <div class="modal-sticky-buttons flex items-center"
                  :class="{ 'justify-between': roomFormData.name, 'justify-end': !roomFormData.name }">
                  <span class="property-name-display" v-if="roomFormData.name">{{ roomFormData.name }}</span>

                  <div class="flex justify-end gap-4">
                    <vs-button @click.prevent="handleSaveRoomType" color="primary">Save</vs-button>
                    <vs-button @click.prevent="closeRoomModal" type="border">Cancel</vs-button>
                  </div>
                </div>

                <!-- Scrollable Content -->
                <div class="modal-scroll-content">
                  <div class="px-6 py-4 space-y-5">
                    <!-- Basic Information Section -->
                    <div class="mb-6">
                      <h4 class="text-lg font-bold mb-4 pb-2 border-b">Basic Information</h4>

                      <div class="vx-row">
                        <div class="vx-col w-full mb-4">
                          <p class="mb-2 font-bold">Room Type Name *</p>
                          <vs-input v-model="roomFormData.name" @input="roomStep1Errors.name = ''"
                            placeholder="Example - Single Room" class="w-full" />
                          <span v-if="roomStep1Errors.name" class="text-danger text-sm">{{ roomStep1Errors.name
                          }}</span>
                        </div>

                        <div class="vx-col w-full mb-4">
                          <p class="mb-2 font-bold">Number Of Rooms *</p>
                          <select-2 class="w-full" name="number-of-rooms" placeholder="Example - 50"
                            :value="roomFormData.number_of_rooms" v-model="roomFormData.number_of_rooms" @input="
                              (item) => {
                                roomFormData.number_of_rooms = item && item.value
                                roomStep1Errors.number_of_rooms = ''
                                if (roomFormData.room_numbers) {
                                  validateRoomNumbers()
                                }
                              }
                            " :options="numberOfRoomsOptions" autocomplete :ssr="false" :multiple="false"
                            :viewRendered="false" :clearable="true" />
                          <span v-if="roomStep1Errors.number_of_rooms" class="text-danger text-sm">{{
                            roomStep1Errors.number_of_rooms
                          }}</span>
                        </div>

                        <div class="vx-col w-full mb-4">
                          <p class="mb-2 font-bold">Room numbers or names *</p>
                          <vs-textarea v-model="roomFormData.room_numbers" @input="validateRoomNumbers"
                            placeholder="Example - 101, 102, 103" height="100px" />
                          <span v-if="roomStep1Errors.room_numbers" class="text-danger text-sm">{{
                            roomStep1Errors.room_numbers
                          }}</span>
                          <p v-if="roomFormData.number_of_rooms && !roomStep1Errors.room_numbers"
                            class="text-base text-gray-600 mt-1">
                            Enter exactly {{ roomFormData.number_of_rooms }} room number(s) or name(s) separated by
                            commas. Example:
                            {{ getExpectedRoomNumbers() }} or custom names like:
                            {{ getCustomNamesExample() }}
                          </p>
                        </div>

                        <div class="vx-col w-full mb-4">
                          <p class="mb-2 font-bold">Room Type Images *</p>
                          <div class="file-upload-wrapper">
                            <label for="room-type-images-upload" class="file-upload-box">
                              <input id="room-type-images-upload" :key="roomTypeFileKey" type="file"
                                class="file-input-hidden" accept=".jpg, .png, .jpeg" @change="handleRoomTypeFileUpload"
                                multiple />
                              <div class="file-upload-content-new">
                                <feather-icon icon="UploadIcon" :svgClasses="['w-6', 'h-6', 'text-black']" />
                                <span class="file-upload-text-new">Browse files to upload image</span>
                              </div>
                            </label>
                          </div>
                          <div class="file-upload-note">
                            <p class="file-upload-note-text">Please note - Only 20 images can be uploaded. File size
                              should be less
                              than 1 MB. Only PNG and JPG format is supported.</p>
                          </div>
                          <span v-if="roomStep1Errors.images" class="text-danger text-sm mt-2 block">{{
                            roomStep1Errors.images
                          }}</span>
                          <div class="mt-4 flex flex-wrap gap-4"
                            v-if="roomFormData.images && roomFormData.images.length > 0">
                            <div v-for="(image, imgIndex) in roomFormData.images" :key="imgIndex" class="relative"
                              style="width: 150px; height: 150px">
                              <img :src="image" alt="Preview"
                                style="width: 100%; height: 100%; object-fit: cover; border-radius: 8px" />
                              <div
                                class="absolute top-0 right-0 text-white rounded-full flex items-center justify-center cursor-pointer"
                                style="width:32px; height:32px; background-color: rgba(0, 0, 0, 0.7);"
                                @click="removeRoomTypeImage(imgIndex)">
                                <feather-icon icon="XIcon" :svgClasses="['w-4', 'h-4']" />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="vx-col w-full mb-4">
                          <p class="mb-2 font-bold">Room Type Description *</p>
                          <vs-textarea v-model="roomFormData.description" @input="roomStep1Errors.description = ''"
                            placeholder="Write brief about the room type" height="150px" />
                          <span v-if="roomStep1Errors.description" class="text-danger text-sm">{{
                            roomStep1Errors.description
                          }}</span>
                        </div>
                      </div>
                    </div>

                    <!-- Pricing Section - Only show if room type doesn't have options -->
                    <div v-if="!hasRoomTypeOptions" class="mb-6">
                      <h4 class="text-lg font-bold mb-4 pb-2 border-b">Pricing</h4>

                      <p class="mb-4 text-md font-bold">Room Type Fees Per Booking</p>

                      <div class="vx-row items-center mb-6">
                        <div class="vx-col w-full md:w-2/3">
                          <h5 class="mb-2 font-bold">Your Charge</h5>
                          <p class="text-gray-600 text-sm md:text-base">Total amount the user will see on the Sangat App
                          </p>
                        </div>
                        <div class="vx-col w-full md:w-1/3 flex justify-end mt-4 md:mt-0">
                          <div class="flex items-center w-full">
                            <span class="px-3 md:px-4 py-3 border rounded-l bg-gray-100">₹</span>
                            <vs-input type="number" min="0" v-model.number="roomFormData.your_charge"
                              @input="handleYourChargeChange" class="w-full" />
                          </div>
                        </div>
                        <span v-if="roomStep2Errors.your_charge" class="text-danger text-sm mt-2 block w-full">{{
                          roomStep2Errors.your_charge }}</span>
                      </div>

                      <vs-divider class="my-4"></vs-divider>

                      <div class="vx-row items-center mb-6">
                        <div class="vx-col w-full md:w-2/3">
                          <h5 class="mb-2 font-bold">Sangat Platform Fee ({{ formData.platform_fee || 0 }}%)</h5>
                          <div class="flex items-center gap-2">
                            <p class="text-gray-600 text-sm md:text-base">This is the fees that will be deduced per
                              booking</p>
                            <div class="tooltip-wrapper">
                              <feather-icon icon="InfoIcon"
                                :svgClasses="['w-4', 'h-4', 'text-grey', 'cursor-pointer']" />
                              <span class="tooltip-text">₹{{ calculatedPlatformFee }} ({{ formData.platform_fee || 0
                              }}%) will be
                                deducted from ₹{{
                                  roomFormData.your_charge || 0 }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="vx-col w-full md:w-1/3 flex justify-end mt-4 md:mt-0">
                          <div
                            class="px-4 py-3 border rounded w-full text-right text-sm md:text-base text-black bg-gray-50">
                            - ₹ {{
                              calculatedPlatformFee }}</div>
                        </div>
                      </div>

                      <vs-divider class="my-4"></vs-divider>

                      <div class="vx-row items-center mb-6">
                        <div class="vx-col w-full md:w-2/3">
                          <h5 class="mb-2 font-bold">You'll receive</h5>
                          <div class="flex items-center gap-2">
                            <p class="text-gray-600 text-sm md:text-base">This is the amount you'll receive pre tax
                              deductions</p>
                            <div class="tooltip-wrapper">
                              <feather-icon icon="InfoIcon"
                                :svgClasses="['w-4', 'h-4', 'text-grey', 'cursor-pointer']" />
                              <span class="tooltip-text">₹{{ roomFormData.net_receive || 0 }} will be received after
                                deducting ₹{{
                                  calculatedPlatformFee }} ({{ formData.platform_fee || 0 }}% platform fee) from ₹{{
                                  roomFormData.your_charge || 0
                                }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="vx-col w-full md:w-1/3 flex justify-end mt-4 md:mt-0">
                          <div class="flex items-center w-full">
                            <span class="px-3 md:px-4 py-3 border rounded-l bg-gray-100">₹</span>
                            <vs-input type="number" min="0" v-model.number="roomFormData.net_receive"
                              @input="handleNetReceiveChange" class="w-full" />
                          </div>
                        </div>
                      </div>
                    </div>


                    <!-- Amenities Section -->
                    <div class="mb-6">
                      <h4 class="text-lg font-bold mb-4 pb-2 border-b">Amenities</h4>

                      <div v-if="amenitiesLoading" class="text-center py-8">
                        <p class="text-gray-500">Loading amenities...</p>
                      </div>

                      <div v-else-if="amenitiesCategories.length === 0" class="text-center py-8">
                        <p class="text-gray-500">No amenities available</p>
                      </div>

                      <div v-else>
                        <div v-for="(category, catIndex) in amenitiesCategories" :key="catIndex"
                          class="amenity-category mb-4 border rounded-lg p-4">
                          <div class="flex items-center justify-between mb-3 cursor-pointer"
                            @click="toggleAmenityCategory(catIndex)">
                            <div class="flex items-center gap-3">
                              <h5 class="font-bold text-lg">{{ category.name }}</h5>
                              <span class="inline-block bg-green-100 text-green-700 rounded px-3 py-1 text-sm"> {{
                                getSelectedAmenitiesCount(category) }}/{{ category.amenities.length }} selected </span>
                            </div>
                            <feather-icon :icon="category.expanded ? 'ChevronUpIcon' : 'ChevronDownIcon'"
                              :svgClasses="['w-5', 'h-5']" />
                          </div>

                          <transition name="slide-fade">
                            <div v-if="category.expanded" class="amenity-items">
                              <div v-for="(amenity, amenityIndex) in category.amenities" :key="amenityIndex"
                                class="flex items-center gap-2 mb-2">
                                <vs-checkbox v-model="amenity.selected" />
                                <label class="cursor-pointer">{{ amenity.name }}</label>
                              </div>
                            </div>
                          </transition>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </vs-popup>

              <!-- Add/Edit Option Modal -->
              <vs-popup :active.sync="showOptionModal" :title="currentOption ? 'Edit Option' : 'Add Option'"
                class="option-modal">
                <!-- Sticky Action Buttons -->
                <div class="modal-sticky-buttons flex gap-4 justify-between items-center">
                  <!-- Subtitle -->
                  <p class="text-base font-semibold capitalize text-gray-600">{{ currentRoomTypeForOption ?
                    currentRoomTypeForOption.name : 'Room Type' }}</p>
                  <div class="flex gap-4">
                    <vs-button type="filled" @click.prevent="handleSaveOption" color="primary">Save</vs-button>
                    <vs-button @click.prevent="closeOptionModal" type="border">Cancel</vs-button>
                  </div>
                </div>

                <!-- Scrollable Content -->
                <div class="modal-scroll-content">
                  <div class="px-6 py-4 space-y-5">

                    <!-- Basic Information Section -->
                    <div class="mb-6">
                      <h4 class="text-lg font-bold mb-4 pb-2 border-b">Basic Information</h4>

                      <div class="vx-row">
                        <div class="vx-col w-full mb-4">
                          <p class="mb-2 font-bold">Option Name *</p>
                          <vs-input v-model="optionFormData.name" @input="optionStep1Errors.name = ''"
                            placeholder="Example - Single Room" class="w-full" />
                          <span v-if="optionStep1Errors.name" class="text-danger text-sm">{{ optionStep1Errors.name
                          }}</span>
                        </div>

                        <div class="vx-col w-full mb-4">
                          <p class="mb-2 font-bold">Up to how many people? *</p>
                          <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3">
                            <div v-for="num in 10" :key="num"
                              class="capacity-toggle-item border rounded-lg p-2 md:p-3 cursor-pointer"
                              :class="{ selected: optionFormData.capacity === num }" @click="
                                optionFormData.capacity = num
                              optionStep1Errors.capacity = ''
                                ">
                              <div class="flex items-center justify-center">
                                <vs-switch :value="optionFormData.capacity === num"
                                  @input="optionFormData.capacity = num">
                                  <span slot="on">On</span>
                                  <span slot="off">Off</span>
                                </vs-switch>
                                <span class="ml-2 font-medium text-sm md:text-base">{{ getNumberWord(num) }}</span>
                              </div>
                            </div>
                          </div>
                          <span v-if="optionStep1Errors.capacity" class="text-danger text-sm mt-2 block">{{
                            optionStep1Errors.capacity
                          }}</span>
                        </div>

                        <div class="vx-col w-full mb-4">
                          <p class="mb-2 font-bold">Option Description *</p>
                          <vs-textarea v-model="optionFormData.description" @input="optionStep1Errors.description = ''"
                            placeholder="What brief about does this option include or exclude" height="150px" />
                          <span v-if="optionStep1Errors.description" class="text-danger text-sm">{{
                            optionStep1Errors.description
                          }}</span>
                        </div>
                      </div>
                    </div>

                    <!-- Pricing Section -->
                    <div class="mb-6">
                      <h4 class="text-lg font-bold mb-4 pb-2 border-b">Pricing</h4>

                      <p class="mb-4 text-md font-bold">Option Fees Per Booking</p>

                      <div class="vx-row items-center mb-6">
                        <div class="vx-col w-full md:w-2/3">
                          <h5 class="mb-2 font-bold">Your Charge</h5>
                          <p class="text-gray-600 text-sm md:text-base">Total amount the user will see on the Sangat App
                          </p>
                        </div>
                        <div class="vx-col w-full md:w-1/3 flex justify-end mt-4 md:mt-0">
                          <div class="flex items-center w-full">
                            <span class="px-3 md:px-4 py-3 border rounded-l bg-gray-100">₹</span>
                            <vs-input type="number" min="0" v-model.number="optionFormData.your_charge"
                              @input="handleOptionYourChargeChange" class="w-full" />
                          </div>
                        </div>
                        <span v-if="optionStep2Errors.your_charge" class="text-danger text-sm mt-2 block w-full">{{
                          optionStep2Errors.your_charge }}</span>
                      </div>

                      <vs-divider class="my-4"></vs-divider>

                      <div class="vx-row items-center mb-6">
                        <div class="vx-col w-full md:w-2/3">
                          <h5 class="mb-2 font-bold">Sangat Platform Fee ({{ formData.platform_fee || 0 }}%)</h5>
                          <div class="flex items-center gap-2">
                            <p class="text-gray-600 text-sm md:text-base">This is the fees that will be deduced per
                              booking</p>
                            <div class="tooltip-wrapper">
                              <feather-icon icon="InfoIcon"
                                :svgClasses="['w-4', 'h-4', 'text-grey', 'cursor-pointer']" />
                              <span class="tooltip-text">₹{{ calculatedOptionPlatformFee }} ({{ formData.platform_fee ||
                                0 }}%) will
                                be deducted from
                                ₹{{
                                  optionFormData.your_charge || 0 }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="vx-col w-full md:w-1/3 flex justify-end mt-4 md:mt-0">
                          <div
                            class="px-4 py-3 border rounded w-full text-right text-sm md:text-base text-black bg-gray-50">
                            - ₹ {{
                              calculatedOptionPlatformFee }}</div>
                        </div>
                      </div>

                      <vs-divider class="my-4"></vs-divider>

                      <div class="vx-row items-center mb-6">
                        <div class="vx-col w-full md:w-2/3">
                          <h5 class="mb-2 font-bold">You'll receive</h5>
                          <div class="flex items-center gap-2">
                            <p class="text-gray-600 text-sm md:text-base">This is the amount you'll receive pre tax
                              deductions</p>
                            <div class="tooltip-wrapper">
                              <feather-icon icon="InfoIcon"
                                :svgClasses="['w-4', 'h-4', 'text-grey', 'cursor-pointer']" />
                              <span class="tooltip-text">₹{{ optionFormData.net_receive || 0 }} will be received after
                                deducting ₹{{
                                  calculatedOptionPlatformFee }} ({{ formData.platform_fee || 0 }}% platform fee) from ₹{{
                                  optionFormData.your_charge ||
                                  0 }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="vx-col w-full md:w-1/3 flex justify-end mt-4 md:mt-0">
                          <div class="flex items-center w-full">
                            <span class="px-3 md:px-4 py-3 border rounded-l bg-gray-100">₹</span>
                            <vs-input type="number" min="0" v-model.number="optionFormData.net_receive"
                              @input="handleOptionNetReceiveChange" class="w-full" />
                          </div>
                        </div>
                      </div>
                    </div>


                  </div>

                </div>
              </vs-popup>
            </div>

            <!-- Step 3: Additional Information -->
            <div class="form-section mb-8">
              <h3 class="section-title mb-0">Additional Info</h3>
              <div class="vx-row">
                  <div class="vx-col w-full mb-4">
                    <p class="mb-2 text-md font-bold">Payment Terms *</p>
                    <vs-textarea v-model="formData.amenities" @input="step3Errors.amenities = ''"
                      placeholder="Write in details about your property fees and terms" height="150px" />
                    <span v-if="step3Errors.amenities" class="text-danger text-sm mt-2 block">{{ step3Errors.amenities
                    }}</span>
                  </div>

                  <div class="vx-col w-full mb-4">
                    <p class="mb-2 text-md font-bold">Rules and Regulations *</p>
                    <vs-textarea v-model="formData.hotel_rules" @input="step3Errors.hotel_rules = ''"
                      placeholder="Write your property rules and regulations here" height="150px" />
                    <span v-if="step3Errors.hotel_rules" class="text-danger text-sm mt-2 block">{{
                      step3Errors.hotel_rules }}</span>
                  </div>

                  <div class="vx-col w-full mb-4">
                    <p class="mb-2 text-md font-bold">Safety Information *</p>
                    <vs-textarea v-model="formData.safety_information" @input="step3Errors.safety_information = ''"
                      placeholder="Write your property safety information here" height="150px" />
                    <span v-if="step3Errors.safety_information" class="text-danger text-sm mt-2 block">{{
                      step3Errors.safety_information }}</span>
                  </div>

                  <div class="vx-col w-full mb-4">
                    <p class="mb-2 text-md font-bold">Cancellation Policy *</p>
                    <vs-textarea v-model="formData.cancellation_policy" @input="step3Errors.cancellation_policy = ''"
                      placeholder="Write your property booking cancellation policy here" height="150px" />
                    <span v-if="step3Errors.cancellation_policy" class="text-danger text-sm mt-2 block">{{
                      step3Errors.cancellation_policy }}</span>
                  </div>

                  <div class="vx-col w-full ">
                    <p class="mb-2 text-md font-bold">Refund Policy *</p>
                    <vs-textarea v-model="formData.refund_policy" @input="step3Errors.refund_policy = ''"
                      placeholder="Write your property booking refund policy here" height="150px" />
                    <span v-if="step3Errors.refund_policy" class="text-danger text-sm mt-2 block">{{
                      step3Errors.refund_policy
                    }}</span>
                  </div>
                </div>
            </div>

            <div class="form-section mb-8 w-full">
              <document-collection-section
                :enabled.sync="collectDocumentsEnabled"
                :documents="documents"
                title="Collect Documents?"
              />
            </div>
          </form>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import axios from '@/axios'
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import Select2 from '@/components/custom/form-elements/Select2.vue'
import DocumentCollectionSection from '@/components/custom/DocumentCollectionSection.vue'
import PercentageInput from '@/components/custom/PercentageInput.vue'
import {
  calcChargeFromNetReceive,
  calcNetReceive,
  calcPlatformFeeAmount,
  clampPlatformFeePercent,
  getPlatformFeeError
} from '@/utils/platformFee'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import moment from 'moment'

export default {
  name: 'HotelForm',
  components: {
    FormWizard,
    TabContent,
    Select2,
    DocumentCollectionSection,
    PercentageInput,
    flatPickr
  },
  props: {
    hotelId: {
      type: String,
      default: null
    },
    gurudwaraId: {
      type: String,
      default: ''
    },
    isEditMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentStep: 0,
      fileKey: 0,
      roomFileKey: {},
      formData: {
        gurudwara: this.gurudwaraId,
        property_name: '',
        description: '', // Property description
        images: [], // Preview URLs for display
        imagesFiles: [], // File objects for FormData upload
        existingImages: [], // Existing image URLs when editing
        amenities: '', // Payment Terms (confusingly named)
        hotel_rules: '',
        cancellation_policy: '',
        safety_information: '',
        refund_policy: '',
        rooms: [],
        is_active: true,
        is_verified: true,
        platform_fee: 0,
        other_name: [],
        youtube_handle_name: [],
        social_media: {
          facebook: '',
          instagram: '',
          twitter: '',
          snapchat: '',
          tiktok: '',
          linkedin: '',
          youtube: ''
        },
        custom_link: [],
        is24hOpen: false,
        opening_hours: [
          { day: 'Sunday', open_time: null, close_time: null },
          { day: 'Monday', open_time: null, close_time: null },
          { day: 'Tuesday', open_time: null, close_time: null },
          { day: 'Wednesday', open_time: null, close_time: null },
          { day: 'Thursday', open_time: null, close_time: null },
          { day: 'Friday', open_time: null, close_time: null },
          { day: 'Saturday', open_time: null, close_time: null }
        ],
        free_wifi: false,
        parking: false
      },
      propertyTypeOptions: [
        { label: 'Gurudwara Hotel ', value: 'hotel' },
        { label: 'Hotel', value: 'hotel' }
      ],
      propertyTypeSelection: 'hotel',

      step1Errors: {},
      step2Errors: {},
      step3Errors: {},
      roomErrors: [],
      roomTypesList: [],
      showRoomModal: false,
      currentRoomType: null,
      roomFormData: {
        name: '',
        number_of_rooms: null,
        room_numbers: '',
        images: [], // Preview URLs for display
        imagesFiles: [], // File objects for FormData upload
        existingImages: [], // Existing image URLs when editing
        description: '',
        your_charge: 0,
        net_receive: 0, // New field for editable net receive amount
        taxes_and_fees: 0,
        amenities: [],
        is_active: true
      },
      roomStep1Errors: {},
      roomStep2Errors: {},
      roomStep3Errors: {},
      roomTypeFileKey: 0,
      amenitiesCategories: [],
      amenitiesLoading: false,
      numberOfRoomsOptions: Array.from({ length: 50 }, (_, i) => ({ value: i + 1, label: String(i + 1) })),
      currentRoomFormStep: 0,
      roomWizardKey: 0,
      showOptionModal: false,
      currentOption: null,
      currentRoomTypeForOption: null,
      optionFormData: {
        name: '',
        capacity: null,
        description: '',
        your_charge: 0,
        net_receive: 0,
        taxes_and_fees: 0,
        is_active: true
      },
      optionStep1Errors: {},
      optionStep2Errors: {},
      currentOptionFormStep: 0,
      validatingStep: false,
      submittingForm: false,
      isSubmitting: false,
      isPublishing: false,
      isSavingDraft: false,
      loaderRetryTimers: {
        next: null,
        finish: null
      },
      dropdownObserver: null,
      dropdownClickHandler: null,
      collectDocumentsEnabled: false,
      documents: [
        { name: 'Aadhaar Card', mandatory: true, hint: 'Upload both front and back side together', _editing: false, _dirty: false, _backup: null },
        { name: 'Passport', mandatory: true, hint: 'Upload both front and back side together', _editing: false, _dirty: false, _backup: null },
        { name: 'PAN Card', mandatory: false, hint: 'Upload both front and back side together', _editing: false, _dirty: false, _backup: null }
      ],
      configdateTimePicker: {
        enableTime: true,
        noCalendar: true,
        dateFormat: 'h:i K'
      },
      WEEK_DAYS: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      lastModifiedDay: null
    }
  },
  watch: {
    propertyTypeSelection: {
      handler(newVal) {
        if (newVal) {
          this.step1Errors.type = ''
        }
      }
    },
    hotelId: {
      immediate: true,
      handler(newVal) {
        const id = newVal != null && newVal !== '' ? String(newVal).trim() : ''
        if (id && this.isEditMode) {
          this.loadHotelData()
        }
      }
    },
    'formData.property_name'() {
      // Clear name error when user starts typing
      if (this.step1Errors.property_name) {
        this.step1Errors.property_name = ''
      }
    },
    'formData.images'() {
      // Clear images error when images are added
      if (this.formData.images && this.formData.images.length > 0 && this.step1Errors.images) {
        this.step1Errors.images = ''
      }
    },
    'formData.platform_fee'() {
      if (this.showRoomModal) {
        this.handleYourChargeChange()
      }
      if (this.showOptionModal) {
        this.handleOptionYourChargeChange()
      }
    },
    'bulkRoomData.room_type'() {
      if (this.bulkRoomErrors.room_type) {
        this.bulkRoomErrors.room_type = ''
      }
    },
    'bulkRoomData.name'() {
      if (this.bulkRoomErrors.name) {
        this.bulkRoomErrors.name = ''
      }
    },
    'bulkRoomData.price_per_night'() {
      if (this.bulkRoomErrors.price_per_night) {
        this.bulkRoomErrors.price_per_night = ''
      }
    },
    'bulkRoomData.quantity'() {
      if (this.bulkRoomErrors.quantity) {
        this.bulkRoomErrors.quantity = ''
      }
    },
    validatingStep(val) {
      // No longer needed for main form, but kept for compatibility
    },
    submittingForm(val) {
      if (val) {
        this.$nextTick(() => {
          this.attachLoaderToSubmitButton()
        })
      } else {
        this.hideSubmitButtonLoader()
      }
    }
  },
  computed: {
    // Computed property for platform fee calculation (20% of your_charge)
    calculatedPlatformFee() {
      return calcPlatformFeeAmount(this.roomFormData.your_charge, this.formData.platform_fee).toFixed(2)
    },
    // Old computed - kept for backward compatibility but uses new calculation
    netReceiveAmount() {
      return calcNetReceive(this.roomFormData.your_charge, this.formData.platform_fee).toFixed(2)
    },
    netReceiveOptionAmount() {
      return calcNetReceive(this.optionFormData.your_charge, this.formData.platform_fee).toFixed(2)
    },
    // Computed property for option platform fee calculation (20% of your_charge)
    calculatedOptionPlatformFee() {
      return calcPlatformFeeAmount(this.optionFormData.your_charge, this.formData.platform_fee).toFixed(2)
    },
    // GST calculation for room
    calculatedRoomGST() {
      const charge = Number(this.roomFormData.your_charge) || 0
      const gstRate = charge <= 7500 ? 5 : 18
      return {
        rate: gstRate,
        amount: ((charge * gstRate) / 100).toFixed(2)
      }
    },
    // GST calculation for option
    calculatedOptionGST() {
      const charge = Number(this.optionFormData.your_charge) || 0
      const gstRate = charge <= 7500 ? 5 : 18
      return {
        rate: gstRate,
        amount: ((charge * gstRate) / 100).toFixed(2)
      }
    },
    // Total amount for room (Your Charge + GST)
    roomTotalWithGST() {
      const charge = Number(this.roomFormData.your_charge) || 0
      const gst = Number(this.calculatedRoomGST.amount) || 0
      return (charge + gst).toFixed(2)
    },
    // Total amount for option (Your Charge + GST)
    optionTotalWithGST() {
      const charge = Number(this.optionFormData.your_charge) || 0
      const gst = Number(this.calculatedOptionGST.amount) || 0
      return (charge + gst).toFixed(2)
    },
    hasRoomTypeOptions() {
      // Check if current room type has options
      if (this.currentRoomType && this.currentRoomType.options && this.currentRoomType.options.length > 0) {
        return true
      }
      // Also check if the room type in the list has options (for edit mode)
      if (this.currentRoomType) {
        const roomTypeInList = this.roomTypesList.find((rt) => rt === this.currentRoomType)
        if (roomTypeInList && roomTypeInList.options && roomTypeInList.options.length > 0) {
          return true
        }
      }
      return false
    },
    /** Hotel managers must not see or change platform fee; admin / superadmin / support staff can */
    canEditHotelPlatformFee() {
      const userInfo = this.$store.state.auth.userInfo
      if (!userInfo || !userInfo.role) return false
      const raw = userInfo.role.slug || userInfo.role.role_name || ''
      const slug = String(raw)
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '-')
      return slug !== 'hotel-manager'
    },
    checkModifiedDay() {
      const modifiedDayData = this.formData.opening_hours.find((day) => day.day === this.lastModifiedDay)
      return modifiedDayData && modifiedDayData.open_time && modifiedDayData.close_time
    }
  },
  mounted() {
    // loadHotelData is triggered by hotelId watcher (immediate) — do not call here or the API runs twice and errors toast duplicate
    this.loadAmenities()
    this.setupDropdownScrollPrevention()
  },
  beforeDestroy() {
    this.clearLoaderRetry('next')
    this.clearLoaderRetry('finish')
    this.removeDropdownScrollPrevention()
  },
  methods: {
    async loadHotelData() {
      const hid = this.hotelId != null && this.hotelId !== '' ? String(this.hotelId).trim() : ''
      if (!hid) return

      try {
        const response = await axios.get(`/admin/hotel/${hid}`)
        if (response.data.success) {
          const data = response.data.data
          const sm = data.social_media && typeof data.social_media === 'object' ? data.social_media : {}
          // Separate existing images (URLs) from new files
          const existingImages = Array.isArray(data.images) ? data.images : []
          const gw =
            this.gurudwaraId ||
            (data.gurudwara && typeof data.gurudwara === 'object' && data.gurudwara !== null
              ? data.gurudwara._id || data.gurudwara
              : data.gurudwara) ||
            ''

          this.formData = {
            gurudwara: gw,
            property_name: data.property_name || data.name || '',
            description: data.description || '', // Property description
            images: existingImages, // Preview URLs (display)
            imagesFiles: [], // New File objects (will be populated on upload)
            existingImages, // Existing image URLs (for tracking)
            amenities: data.amenities || '', // Payment Terms
            hotel_rules: data.hotel_rules || '',
            cancellation_policy: data.cancellation_policy || '',
            safety_information: data.safety_information || '',
            refund_policy: data.refund_policy || '',
            rooms: data.rooms ? data.rooms.map(room => ({
              ...room,
              images: Array.isArray(room.images) ? room.images : [],
              imagesFiles: [],
              existingImages: Array.isArray(room.images) ? room.images : []
            })) : [],
            is_active: data.is_active !== undefined ? data.is_active : true,
            is_verified: data.is_verified !== undefined ? data.is_verified : true,
            platform_fee: clampPlatformFeePercent(data.platform_fee || 0),
            other_name: data.other_name || [],
            youtube_handle_name: data.youtube_handle_name || [],
            social_media: {
              facebook: sm.facebook || '',
              instagram: sm.instagram || '',
              twitter: sm.twitter || '',
              snapchat: sm.snapchat || '',
              tiktok: sm.tiktok || '',
              linkedin: sm.linkedin || '',
              youtube: sm.youtube || ''
            },
            custom_link: data.custom_link || [],
            is24hOpen: !!data.is24hOpen,
            opening_hours: data.opening_hours && data.opening_hours.length > 0 ? data.opening_hours.map(oh => ({
              ...oh,
              open_time: oh.open_time ? moment(oh.open_time).local().format('hh:mm A') : null,
              close_time: oh.close_time ? moment(oh.close_time).local().format('hh:mm A') : null
            })) : [
              { day: 'Sunday', open_time: null, close_time: null },
              { day: 'Monday', open_time: null, close_time: null },
              { day: 'Tuesday', open_time: null, close_time: null },
              { day: 'Wednesday', open_time: null, close_time: null },
              { day: 'Thursday', open_time: null, close_time: null },
              { day: 'Friday', open_time: null, close_time: null },
              { day: 'Saturday', open_time: null, close_time: null }
            ],
            free_wifi: !!data.free_wifi,
            parking: !!data.parking
          }
          // Convert rooms to roomTypesList format
          this.convertRoomsToRoomTypes(data.rooms || [])

          // Load document collection settings
          this.collectDocumentsEnabled = !!data.is_documentCollect
          if (Array.isArray(data.collect_documents) && data.collect_documents.length > 0) {
            this.documents = data.collect_documents.map((doc) => ({
              _editing: false,
              _dirty: false,
              _backup: null,
              name: doc.document_name || doc.name,
              mandatory: doc.is_required !== undefined && doc.is_required !== null ? doc.is_required : doc.mandatory,
              hint: doc.description || doc.hint
            }))
          } else {
            // Add reactive properties to default documents if no documents exist
            this.documents = this.documents.map((doc) => ({
              _editing: false,
              _dirty: false,
              _backup: null,
              name: doc.name,
              mandatory: doc.mandatory,
              hint: doc.hint
            }))
          }
        }
      } catch (error) {
        const msg =
          (error.response && error.response.data && error.response.data.message) ||
          error.message ||
          'Failed to load hotel data'
        this.$vs.notify({
          title: 'Error',
          text: msg,
          color: 'danger'
        })
      }
    },
    convertRoomsToRoomTypes(rooms) {
      // Group rooms by room_type name and combine them into single entries
      const roomTypeMap = {}

      rooms.forEach((room) => {
        const roomTypeName = room.room_type || room.name || `Room Type`
        const numRooms = room.number_of_rooms || 1

        if (!roomTypeMap[roomTypeName]) {
          // First room of this type - create entry
          const roomImages = Array.isArray(room.images) ? room.images : []
          roomTypeMap[roomTypeName] = {
            name: roomTypeName,
            number_of_rooms: numRooms,
            room_numbers: room.room_name || room.room_numbers || '',
            images: roomImages, // Preview URLs (display)
            imagesFiles: [], // New File objects (will be populated on upload)
            existingImages: roomImages, // Existing image URLs (for tracking)
            description: room.description || '',
            amenities: room.amenities || [],
            is_active: room.is_active !== undefined ? room.is_active : true,
            options: room.options || [],
            showOptions: room.options && room.options.length > 0,
            your_charge: room.price_per_night || 0,
            price_per_night: room.price_per_night || 0,
            taxes_and_fees: room.taxes_and_fees || 0,
            net_receive: room.received_amount || 0
          }
        } else {
          // Additional room of same type - increment count and append room number
          roomTypeMap[roomTypeName].number_of_rooms += numRooms
          const roomName = room.room_name || room.room_numbers || ''
          if (roomName) {
            const existingNumbers = roomTypeMap[roomTypeName].room_numbers
            roomTypeMap[roomTypeName].room_numbers = existingNumbers
              ? `${existingNumbers}, ${roomName}`
              : roomName
          }
          // Use options from first room (they should be the same for all rooms of same type)
          if (!roomTypeMap[roomTypeName].options.length && room.options && room.options.length > 0) {
            roomTypeMap[roomTypeName].options = room.options
          }
        }
      })

      // Convert map to array
      this.roomTypesList = Object.values(roomTypeMap)
    },
    isPropertyTypeSelected(value) {
      if (!value || !this.propertyTypeSelection) return false
      const normalizedValue = this.normalizePropertyTypeValue(value)
      const normalizedSelection = this.normalizePropertyTypeValue(this.propertyTypeSelection)
      return normalizedValue === normalizedSelection
    },
    normalizePropertyTypeValue(value) {
      if (value === null || value === undefined) return null
      const normalized = String(value).toLowerCase()
      if (normalized.includes('hotel')) return 'hotel'
      if (normalized.includes('hotel')) return 'hotel'
      return String(value).toLowerCase()
    },
    normalizePropertyLocations(values) {
      if (!Array.isArray(values)) return ['Hotel']
      const normalized = values.map((value) => this.normalizePropertyTypeValue(value)).filter(Boolean)
      return normalized.length ? Array.from(new Set(normalized)) : ['Hotel']
    },
    // Add these methods to your component's methods section:

    // Handler when "Your Charge" changes - updates net_receive
    handlePlatformFeeInput() {
      const raw = this.formData.platform_fee
      if (raw === '' || raw === null || raw === undefined) {
        this.step1Errors.platform_fee = 'Platform fee is required'
        return
      }
      const clamped = clampPlatformFeePercent(raw)
      if (clamped !== Number(raw)) {
        this.formData.platform_fee = clamped
      }
      this.step1Errors.platform_fee = getPlatformFeeError(this.formData.platform_fee)
    },
    handleYourChargeChange() {
      this.roomStep2Errors.your_charge = ''
      this.roomFormData.net_receive = calcNetReceive(this.roomFormData.your_charge, this.formData.platform_fee)
    },

    // Handler when "You'll receive" changes - updates your_charge
    handleNetReceiveChange() {
      this.roomFormData.your_charge = calcChargeFromNetReceive(this.roomFormData.net_receive, this.formData.platform_fee)
      this.roomStep2Errors.your_charge = ''
    },

    closeRoomModal() {
      this.showRoomModal = false
      this.currentRoomType = null
      this.roomFormData = {
        name: '',
        number_of_rooms: null,
        room_numbers: '',
        images: [], // Preview URLs for display
        imagesFiles: [], // File objects for FormData upload
        existingImages: [], // Existing image URLs when editing
        description: '',
        your_charge: 0,
        net_receive: 0,
        taxes_and_fees: 0,
        amenities: [],
        is_active: true
      }
      this.roomStep1Errors = {}
      this.roomStep2Errors = {}
      this.roomStep3Errors = {}
    },
    handle24hToggle() {
      this.formData.opening_hours.forEach((day) => {
        day.open_time = null
        day.close_time = null
      })
    },
    copyToAllDays() {
      const modifiedDayData = this.formData.opening_hours.find((day) => day.day === this.lastModifiedDay)
      if (modifiedDayData) {
        this.formData.opening_hours.forEach((day) => {
          day.open_time = modifiedDayData.open_time
          day.close_time = modifiedDayData.close_time
          // Clear error for all days since we copied a valid time
          this.$delete(this.step1Errors, day.day)
        })
      }
    },
    validateTime(day, date, type) {
      if (!date) return
      this.lastModifiedDay = day

      const dayData = this.formData.opening_hours.find((d) => d.day === day)
      // Ensure dayData exists and there is an open_time or close_time to validate against
      if (!dayData || (!dayData.open_time && !dayData.close_time)) {
        return
      }

      let openTime, closeTime
      if (type === 'open_time') {
        openTime = moment(date, 'hh:mm A')
          .set({ year: 1970, month: 0, date: 1 })
          .utcOffset(moment().utcOffset())
          .utc()
          .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
        closeTime = dayData.close_time ? moment(dayData.close_time, 'hh:mm A')
          .set({ year: 1970, month: 0, date: 1 })
          .utcOffset(moment().utcOffset())
          .utc()
          .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : null
      } else if (type === 'close_time') {
        openTime = dayData.open_time ? moment(dayData.open_time, 'hh:mm A')
          .set({ year: 1970, month: 0, date: 1 })
          .utcOffset(moment().utcOffset())
          .utc()
          .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : null
        closeTime = moment(date, 'hh:mm A')
          .set({ year: 1970, month: 0, date: 1 })
          .utcOffset(moment().utcOffset())
          .utc()
          .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
      }

      // Validate that close time must be strictly after open time
      if (closeTime && openTime && closeTime <= openTime) {
        this.$set(this.step1Errors, day, `${day} close time must be after open time`)
      } else {
        this.$delete(this.step1Errors, day) // Remove error if valid
      }
    },
    addOtherLink() {
      this.formData.custom_link.push({ title: '', link: '' })
    },
    removeOtherLink(index) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: 'Are you sure you want to delete this link?',
        accept: () => {
          this.formData.custom_link.splice(index, 1)
        }
      })
    },
    addData(type) {
      if (type === 'other_name') {
        this.formData.other_name.push('')
      } else if (type === 'youtube_handle_name') {
        this.formData.youtube_handle_name.push('')
      }
    },
    removeData(type, index) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: 'Are you sure you want to delete this item?',
        accept: () => {
          if (type === 'other_name') {
            this.formData.other_name.splice(index, 1)
          } else if (type === 'youtube_handle_name') {
            this.formData.youtube_handle_name.splice(index, 1)
          }
        }
      })
    },

    validateRoomForm() {
      // Reset all errors
      this.roomStep1Errors = {}
      this.roomStep2Errors = {}
      this.roomStep3Errors = {}

      let isValid = true

      // Validate Basic Information
      if (!this.roomFormData.name || this.roomFormData.name.trim() === '') {
        this.roomStep1Errors.name = 'Room Type Name is required'
        isValid = false
      }

      if (!this.roomFormData.number_of_rooms) {
        this.roomStep1Errors.number_of_rooms = 'Number Of Rooms is required'
        isValid = false
      }

      if (!this.roomFormData.room_numbers || this.roomFormData.room_numbers.trim() === '') {
        this.roomStep1Errors.room_numbers = 'Room numbers or names is required'
        isValid = false
      } else if (this.roomFormData.number_of_rooms) {
        // Validate room numbers count matches the number of rooms
        const numRooms = Number(this.roomFormData.number_of_rooms)
        const enteredNumbers = this.roomFormData.room_numbers.trim()
        const roomNumbersList = enteredNumbers
          .split(',')
          .map((n) => n.trim())
          .filter((n) => n)

        if (roomNumbersList.length !== numRooms) {
          const expectedNumbers = this.getExpectedRoomNumbers()
          this.roomStep1Errors.room_numbers = `You must enter exactly ${numRooms} room number(s) or name(s). Expected format: ${expectedNumbers}`
          isValid = false
        }
      }

      // Validate images - mandatory field (check both existing images and new files)
      const existingImagesCount = this.roomFormData.existingImages ? this.roomFormData.existingImages.length : 0
      const newFilesCount = this.roomFormData.imagesFiles ? this.roomFormData.imagesFiles.length : 0
      const totalImages = existingImagesCount + newFilesCount

      if (totalImages === 0) {
        this.roomStep1Errors.images = 'Room Type Images are required'
        isValid = false
      }

      if (!this.roomFormData.description || this.roomFormData.description.trim() === '') {
        this.roomStep1Errors.description = 'Room Type Description is required'
        isValid = false
      }

      // Validate Pricing - Only if room type doesn't have options
      if (!this.hasRoomTypeOptions) {
        if (!this.roomFormData.your_charge || this.roomFormData.your_charge <= 0) {
          this.roomStep2Errors.your_charge = 'Your Charge is required and must be greater than 0'
          isValid = false
        } else {
          const platformFee = Number(this.calculatedPlatformFee) || 0
          if (this.roomFormData.your_charge < platformFee) {
            this.roomStep2Errors.your_charge = `Your Charge must be at least the Sangat platform fee (₹${platformFee})`
            isValid = false
          }
        }
      }

      return isValid
    },

    async handleSaveRoomType() {
      // Validate the form
      if (!this.validateRoomForm()) {
        this.$vs.notify({
          title: 'Validation Error',
          text: 'Please fill all required fields correctly',
          color: 'warning'
        })

        // Scroll to first error
        this.$nextTick(() => {
          const firstError = document.querySelector('.room-type-modal .text-danger')
          if (firstError) {
            firstError.scrollIntoView({ behavior: 'smooth', block: 'center' })
          }
        })
        return
      }

      try {
        // Collect selected amenities
        const selectedAmenities = []
        this.amenitiesCategories.forEach((category) => {
          category.amenities.forEach((amenity) => {
            if (amenity.selected) {
              const amenityValue = amenity.value || this.convertToSnakeCase(amenity.name)
              selectedAmenities.push(amenityValue)
            }
          })
        })

        const platformFee = Number(this.calculatedPlatformFee) || 0
        const yourCharge = Number(this.roomFormData.your_charge || 0)
        const receivedAmount = Number(this.roomFormData.net_receive || 0) || Math.max(0, yourCharge - platformFee)

        // Get existing options or empty array
        const existingOptions = this.currentRoomType && this.currentRoomType.options ? this.currentRoomType.options : []
        const hasOptions = existingOptions && existingOptions.length > 0

        const roomNumbersList = this.roomFormData.room_numbers
          .split(',')
          .map((n) => n.trim())
          .filter((n) => n)

        // Keep as single entry with number_of_rooms preserved (frontend shows 1 entry, backend will split)
        const numRooms = Number(this.roomFormData.number_of_rooms) || 1
        const roomTypeData = {
          name: this.roomFormData.name,
          number_of_rooms: numRooms, // Preserve number of rooms
          room_numbers: this.roomFormData.room_numbers, // Keep all room numbers as comma-separated string
          images: this.roomFormData.images,
          imagesFiles: this.roomFormData.imagesFiles || [],
          existingImages: this.roomFormData.existingImages || [],
          description: this.roomFormData.description,
          // Always include price fields
          price_per_night: yourCharge,
          your_charge: yourCharge,
          taxes_and_fees: platformFee,
          net_receive: receivedAmount,
          received_amount: receivedAmount,
          amenities: selectedAmenities,
          is_active: this.roomFormData.is_active,
          options: existingOptions,
          showOptions: existingOptions && existingOptions.length > 0
        }

        if (this.currentRoomType) {
          // Edit mode - update existing entry
          const index = this.roomTypesList.findIndex((rt) => rt === this.currentRoomType)
          if (index !== -1) {
            this.$set(this.roomTypesList, index, roomTypeData)
          }
        } else {
          // Add mode - add single entry
          this.roomTypesList.push(roomTypeData)
        }

        this.$vs.notify({
          title: 'Success',
          text: `Room type ${this.currentRoomType ? 'updated' : 'created'} successfully`,
          color: 'success'
        })

        this.closeRoomModal()
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.message || 'Failed to save room type',
          color: 'danger'
        })
      }
    },
    addRoom() {
      if (this.getTotalRoomsCount() >= 50) {
        this.$vs.notify({
          title: 'Limit Reached',
          text: 'Maximum 50 rooms allowed. Please contact admin to add more rooms.',
          color: 'warning'
        })
        return
      }
      this.formData.rooms.push({
        name: '',
        description: '',
        bed_type: '',
        room_size: '',
        capacity: 1,
        price_per_night: null,
        original_price: null,
        images: [],
        extra_bedding_available: false,
        extra_bedding_price: null,
        is_active: true
      })
    },
    getTotalRoomsCount() {
      return this.formData.rooms ? this.formData.rooms.length : 0
    },
    closeBulkRoomModal() {
      this.showBulkRoomModal = false
      this.bulkRoomData = {
        name: '',
        description: '',
        bed_type: '',
        room_size: '',
        capacity: 1,
        price_per_night: null,
        original_price: null,
        quantity: 1,
        extra_bedding_available: false,
        extra_bedding_price: null,
        is_active: true
      }
      this.bulkRoomErrors = {}
    },
    async addBulkRooms() {
      this.$vs.loading({ container: '#add-bulk-rooms-btn', scale: 0.45 })

      // Validate bulk room data
      this.bulkRoomErrors = {}

      if (!this.bulkRoomData.room_type) {
        this.bulkRoomErrors.room_type = 'Room type is required'
      }
      if (!this.bulkRoomData.name || this.bulkRoomData.name.trim() === '') {
        this.bulkRoomErrors.name = 'Room name is required'
      }
      if (!this.bulkRoomData.price_per_night || this.bulkRoomData.price_per_night <= 0) {
        this.bulkRoomErrors.price_per_night = 'Valid price per night is required'
      }
      if (!this.bulkRoomData.quantity || this.bulkRoomData.quantity < 1) {
        this.bulkRoomErrors.quantity = 'Quantity must be at least 1'
      }
      if (this.bulkRoomData.quantity > 50) {
        this.bulkRoomErrors.quantity = 'Maximum 50 rooms allowed at once'
      }

      const currentCount = this.getTotalRoomsCount()
      const newCount = currentCount + this.bulkRoomData.quantity

      if (newCount > 50) {
        this.bulkRoomErrors.quantity = `Cannot add ${this.bulkRoomData.quantity} rooms. You can only add ${50 - currentCount} more rooms (50 max limit). Please contact admin to add more.`
      }

      if (Object.keys(this.bulkRoomErrors).length > 0) {
        this.$vs.loading.close('#add-bulk-rooms-btn > .con-vs-loading')
        return
      }

      // Add a small delay to show the loader
      await new Promise((resolve) => setTimeout(resolve, 300))

      // Create multiple rooms with same data
      const quantity = Math.min(this.bulkRoomData.quantity, 50 - currentCount)

      for (let i = 0; i < quantity; i++) {
        const roomNumber = currentCount + i + 1
        this.formData.rooms.push({
          room_type: this.bulkRoomData.room_type,
          name: `${this.bulkRoomData.name}`,
          description: this.bulkRoomData.description || '',
          bed_type: this.bulkRoomData.bed_type || '',
          room_size: this.bulkRoomData.room_size || '',
          capacity: this.bulkRoomData.room_type === 'dormitory_hall' ? this.bulkRoomData.capacity || 20 : 1,
          price_per_night: this.bulkRoomData.price_per_night,
          original_price: this.bulkRoomData.original_price || null,
          images: [],
          extra_bedding_available: this.bulkRoomData.extra_bedding_available || false,
          extra_bedding_price: this.bulkRoomData.extra_bedding_price || null,
          is_active: true
        })
      }

      this.$vs.loading.close('#add-bulk-rooms-btn > .con-vs-loading')

      this.$vs.notify({
        title: 'Success',
        text: `Successfully added ${quantity} room(s)`,
        color: 'success'
      })

      this.closeBulkRoomModal()
    },
    removeRoom(index) {
      const room = this.formData.rooms[index]
      const roomName = room ? room.name || `Room ${index + 1}` : `Room ${index + 1}`

      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `Are you sure you want to delete "${roomName}"? This action cannot be undone.`,
        accept: () => {
          // Delete only the room at the specific index
          this.formData.rooms.splice(index, 1)
          this.$vs.notify({
            title: 'Success',
            text: 'Room deleted successfully',
            color: 'success'
          })
        },
        cancel: () => {
          // User cancelled, do nothing
        }
      })
    },
    handleFileUpload(event) {
      const files = Array.from(event.target.files)
      const maxFiles = 20
      const maxFileSize = 1 * 1024 * 1024 // 1 MB in bytes
      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png']

      // Clear previous errors
      if (this.step1Errors.images) {
        this.step1Errors.images = ''
      }

      // Initialize arrays if needed
      if (!this.formData.images) {
        this.formData.images = []
      }
      if (!this.formData.imagesFiles) {
        this.formData.imagesFiles = []
      }

      // Check total count (existing images + existing files + new files)
      const existingPreviewCount = this.formData.existingImages ? this.formData.existingImages.length : 0
      const currentFileCount = this.formData.imagesFiles ? this.formData.imagesFiles.length : 0
      const currentCount = existingPreviewCount + currentFileCount

      if (currentCount + files.length > maxFiles) {
        this.step1Errors.images = `Maximum ${maxFiles} images allowed. You can only upload ${maxFiles - currentCount} more image(s).`
        this.fileKey++
        return
      }

      // Validate each file
      const invalidFiles = []
      const validFiles = []

      files.forEach((file) => {
        // Check file type
        if (!allowedTypes.includes(file.type)) {
          invalidFiles.push(`${file.name} - Invalid format. Only PNG and JPG are supported.`)
          return
        }

        // Check file size
        if (file.size > maxFileSize) {
          invalidFiles.push(`${file.name} - File size exceeds 1 MB.`)
          return
        }

        // Valid file - store File object and create preview
        validFiles.push(file)

        // Create preview for display
        const reader = new FileReader()
        reader.onload = (e) => {
          this.formData.images.push(e.target.result)
        }
        reader.readAsDataURL(file)
      })

      // Add valid File objects to imagesFiles array
      this.formData.imagesFiles.push(...validFiles)

      // Show errors for invalid files
      if (invalidFiles.length > 0) {
        this.step1Errors.images = invalidFiles.join(' ')
        this.$vs.notify({
          title: 'Upload Error',
          text: 'Some files were not uploaded. Please check the requirements.',
          color: 'warning'
        })
      }

      this.fileKey++
    },
    removeImage(index) {
      // Remove from preview array
      this.formData.images.splice(index, 1)

      // Calculate if we're removing an existing image or a new file
      const existingCount = this.formData.existingImages ? this.formData.existingImages.length : 0

      if (index < existingCount) {
        // Removing an existing image
        this.formData.existingImages.splice(index, 1)
      } else {
        // Removing a new file - adjust index to account for existing images
        const fileIndex = index - existingCount
        if (this.formData.imagesFiles && fileIndex >= 0 && fileIndex < this.formData.imagesFiles.length) {
          this.formData.imagesFiles.splice(fileIndex, 1)
        }
      }

      // Clear error if images exist after removal
      const totalImages = (this.formData.existingImages ? this.formData.existingImages.length : 0) +
        (this.formData.imagesFiles ? this.formData.imagesFiles.length : 0)
      if (totalImages > 0 && this.step1Errors.images) {
        this.step1Errors.images = ''
      }
      this.fileKey++
    },
    handleRoomFileUpload(event, roomIndex) {
      const files = Array.from(event.target.files)
      if (!this.formData.rooms[roomIndex]) {
        this.$set(this.formData.rooms, roomIndex, {})
      }
      if (!this.formData.rooms[roomIndex].images) {
        this.$set(this.formData.rooms[roomIndex], 'images', [])
      }
      if (!this.formData.rooms[roomIndex].imagesFiles) {
        this.$set(this.formData.rooms[roomIndex], 'imagesFiles', [])
      }
      if (!this.formData.rooms[roomIndex].existingImages) {
        this.$set(this.formData.rooms[roomIndex], 'existingImages', [])
      }

      files.forEach((file) => {
        // Store File object
        this.formData.rooms[roomIndex].imagesFiles.push(file)

        // Create preview for display
        const reader = new FileReader()
        reader.onload = (e) => {
          this.formData.rooms[roomIndex].images.push(e.target.result)
        }
        reader.readAsDataURL(file)
      })
      if (!this.roomFileKey[roomIndex]) {
        this.$set(this.roomFileKey, roomIndex, 0)
      }
      this.roomFileKey[roomIndex]++
    },
    removeRoomImage(roomIndex, imageIndex) {
      if (!this.formData.rooms[roomIndex]) return

      // Remove from preview array
      this.formData.rooms[roomIndex].images.splice(imageIndex, 1)

      // Calculate if we're removing an existing image or a new file
      const existingCount = this.formData.rooms[roomIndex].existingImages ? this.formData.rooms[roomIndex].existingImages.length : 0

      if (imageIndex < existingCount) {
        // Removing an existing image
        if (this.formData.rooms[roomIndex].existingImages) {
          this.formData.rooms[roomIndex].existingImages.splice(imageIndex, 1)
        }
      } else {
        // Removing a new file - adjust index to account for existing images
        const fileIndex = imageIndex - existingCount
        if (this.formData.rooms[roomIndex].imagesFiles && fileIndex >= 0 && fileIndex < this.formData.rooms[roomIndex].imagesFiles.length) {
          this.formData.rooms[roomIndex].imagesFiles.splice(fileIndex, 1)
        }
      }

      if (!this.roomFileKey[roomIndex]) {
        this.$set(this.roomFileKey, roomIndex, 0)
      }
      this.roomFileKey[roomIndex]++
    },

    // Option Pricing Handlers
    handleOptionYourChargeChange() {
      this.optionStep2Errors.your_charge = ''
      this.optionFormData.net_receive = calcNetReceive(this.optionFormData.your_charge, this.formData.platform_fee)
    },

    handleOptionNetReceiveChange() {
      this.optionFormData.your_charge = calcChargeFromNetReceive(this.optionFormData.net_receive, this.formData.platform_fee)
      this.optionStep2Errors.your_charge = ''
    },
    clearRoomError(roomIndex, field) {
      if (this.roomErrors[roomIndex] && this.roomErrors[roomIndex][field]) {
        this.$set(this.roomErrors[roomIndex], field, '')
      }
    },
    validateStep1() {
      return new Promise((resolve, reject) => {
        this.step1Errors = {}
        let isValid = true

        // Validate property type
        if (!this.propertyTypeSelection) {
          this.step1Errors.type = 'Property Type is required'
          isValid = false
        }

        if (!this.formData.property_name || this.formData.property_name.trim() === '') {
          this.step1Errors.property_name = 'Property Name is required'
          isValid = false
        }

        if (this.canEditHotelPlatformFee) {
          if (this.formData.platform_fee === undefined || this.formData.platform_fee === null || this.formData.platform_fee === '') {
            this.step1Errors.platform_fee = 'Platform Fee is required'
            isValid = false
          } else {
            const platformFeeError = getPlatformFeeError(this.formData.platform_fee)
            if (platformFeeError) {
              this.step1Errors.platform_fee = platformFeeError
              isValid = false
            } else {
              this.formData.platform_fee = clampPlatformFeePercent(this.formData.platform_fee)
            }
          }
        }

        // Validate images - mandatory field (check both existing images and new files)
        const existingImagesCount = this.formData.existingImages ? this.formData.existingImages.length : 0
        const newFilesCount = this.formData.imagesFiles ? this.formData.imagesFiles.length : 0
        const totalImages = existingImagesCount + newFilesCount

        if (totalImages === 0) {
          this.step1Errors.images = 'Property Images are required'
          isValid = false
        }

        if (!this.formData.description || this.formData.description.trim() === '') {
          this.step1Errors.description = 'Property Description is required'
          isValid = false
        }

        if (isValid) {
          resolve(true)
        } else {
          reject('correct all values')
        }
      })
    },
    validateStep2() {
      return new Promise((resolve, reject) => {
        const isValid = true

        if (this.roomTypesList.length === 0) {
          this.$vs.notify({
            title: 'Error',
            text: 'Please add at least one room type',
            color: 'danger'
          })
          reject('Please add at least one room type')
          return
        }

        // Convert roomTypesList back to rooms format for submission
        this.convertRoomTypesToRooms()

        if (isValid) {
          resolve(true)
        } else {
          reject('correct all values')
        }
      })
    },
    convertRoomTypesToRooms() {
      // Convert roomTypesList to formData.rooms format for API submission
      // Split entries when number_of_rooms > 1 (frontend shows 1 entry, backend gets multiple)
      this.formData.rooms = []

      this.roomTypesList.forEach((roomType) => {
        const hasOptions = roomType.options && roomType.options.length > 0
        const yourCharge = Number(roomType.your_charge || roomType.price_per_night || 0)
        const currentPlatformFee = calcPlatformFeeAmount(yourCharge, this.formData.platform_fee)
        const receivedAmount = Number(roomType.net_receive || calcNetReceive(yourCharge, this.formData.platform_fee))

        // Process room options (shared across all rooms of this type)
        const processedOptions = (roomType.options || []).map((option) => {
          const optionCharge = Number(option.your_charge || option.price || 0)
          const optionPlatformFee = calcPlatformFeeAmount(optionCharge, this.formData.platform_fee)
          const optionReceivedAmount = Number(option.net_receive || calcNetReceive(optionCharge, this.formData.platform_fee))

          return {
            name: option.name,
            capacity: option.capacity,
            description: option.description,
            price: optionCharge,
            taxes_and_fees: optionPlatformFee, // Platform fee
            received_amount: optionReceivedAmount, // Your charge - platform fee
            is_active: option.is_active !== undefined ? option.is_active : true
          }
        })

        const numRooms = Number(roomType.number_of_rooms) || 1

        // Create single room entry for the room type (backend handles expansion if needed)
        const roomData = {
          room_type: roomType.name,
          room_name: roomType.room_numbers || `${roomType.name} (x${numRooms})`,
          description: roomType.description,
          images: roomType.images || [], // Preview URLs for display
          imagesFiles: roomType.imagesFiles || [], // File objects for FormData upload
          existingImages: roomType.existingImages || [], // Existing image URLs when editing
          amenities: roomType.amenities || [],
          is_active: roomType.is_active !== undefined ? roomType.is_active : true,
          number_of_rooms: numRooms, // Send actual count
          options: processedOptions // All rooms share the same options
        }

        if (hasOptions) {
          // Commented out pricing fields as room has options
          // roomData.price_per_night = yourCharge
          // roomData.taxes_and_fees = currentPlatformFee // Platform fee
          // roomData.received_amount = receivedAmount // Your charge - platform fee
        } else {
          // Include price fields if no options
          roomData.price_per_night = yourCharge
          roomData.taxes_and_fees = currentPlatformFee // Platform fee
          roomData.received_amount = receivedAmount // Your charge - platform fee
        }

        this.formData.rooms.push(roomData)
      })
    },
    validateStep3() {
      return new Promise((resolve, reject) => {
        this.step3Errors = {}
        let isValid = true

        // Validate Payment Terms (amenities field)
        if (!this.formData.amenities || this.formData.amenities.trim() === '') {
          this.step3Errors.amenities = 'Payment Terms is required'
          isValid = false
        }

        // Validate Rules and Regulations
        if (!this.formData.hotel_rules || this.formData.hotel_rules.trim() === '') {
          this.step3Errors.hotel_rules = 'Rules and Regulations is required'
          isValid = false
        }

        // Validate Safety Information
        if (!this.formData.safety_information || this.formData.safety_information.trim() === '') {
          this.step3Errors.safety_information = 'Safety Information is required'
          isValid = false
        }

        // Validate Cancellation Policy
        if (!this.formData.cancellation_policy || this.formData.cancellation_policy.trim() === '') {
          this.step3Errors.cancellation_policy = 'Cancellation Policy is required'
          isValid = false
        }

        // Validate Refund Policy
        if (!this.formData.refund_policy || this.formData.refund_policy.trim() === '') {
          this.step3Errors.refund_policy = 'Refund Policy is required'
          isValid = false
        }

        if (isValid) {
          this.submitForm()
            .then(() => resolve(true))
            .catch((err) => reject(err && err.message ? err.message : 'Submission failed'))
        } else {
          reject('Please fill all required fields')
        }
      })
    },
    updateCurrentStep(step) {
      this.currentStep = step
    },
    async handleFormSubmit() {
      // Prevent double submission
      if (this.isSubmitting) {
        return
      }

      // Validate all steps before submission
      try {
        // Validate Step 1
        await this.validateStep1()

        // Validate Step 2
        await this.validateStep2()

        // Validate Step 3 and submit (validateStep3 already calls submitForm)
        await this.validateStep3()
      } catch (error) {
        // Validation errors are already shown in the UI
        // Scroll to first error if needed
        this.$nextTick(() => {
          const firstError = this.$el.querySelector('.text-danger')
          if (firstError) {
            firstError.scrollIntoView({ behavior: 'smooth', block: 'center' })
          }
        })
      }
    },
    handleCancel() {
      this.$emit('cancelled')
    },
    async handleSaveAsDraft() {
      // Save as draft without full validation
      if (this.isSubmitting) {
        return
      }

      this.isSubmitting = true
      this.isSavingDraft = true
      this.submittingForm = false

      this.$nextTick(() => {
        this.attachLoaderToDraftButton()
      })

      try {
        const collect_documents = this.collectDocumentsEnabled
          ? this.documents.map((doc) => ({
            document_name: doc.name,
            is_required: doc.mandatory,
            description: doc.hint
          }))
          : []

        // Convert roomTypesList to rooms format
        this.convertRoomTypesToRooms()

        // Check if we have any File objects to upload (property images or room images)
        const hasPropertyImages = this.formData.imagesFiles && this.formData.imagesFiles.length > 0
        const hasRoomImages = this.formData.rooms && this.formData.rooms.some(room => room.imagesFiles && room.imagesFiles.length > 0
        )
        const hasImagesToUpload = hasPropertyImages || hasRoomImages

        // Build payload - don't include image Files here, they'll be in FormData
        const payload = {
          gurudwara: this.formData.gurudwara,
          property_name: this.formData.property_name,
          description: this.formData.description,
          // Include existing images (URLs) but not new File objects
          images: hasImagesToUpload ? (this.formData.existingImages || []) : (this.formData.images || []),
          amenities: this.formData.amenities || '',
          hotel_rules: this.formData.hotel_rules || '',
          cancellation_policy: this.formData.cancellation_policy || '',
          safety_information: this.formData.safety_information || '',
          refund_policy: this.formData.refund_policy || '',
          other_name: this.formData.other_name,
          youtube_handle_name: this.formData.youtube_handle_name,
          social_media: this.formData.social_media,
          custom_link: this.formData.custom_link,
          is24hOpen: !!this.formData.is24hOpen,
          opening_hours: this.formData.is24hOpen ? [] : this.formData.opening_hours.map(oh => ({
            day: oh.day,
            open_time: oh.open_time ? moment(oh.open_time, 'hh:mm A').set({ year: 1970, month: 0, date: 1 }).utc().toISOString() : null,
            close_time: oh.close_time ? moment(oh.close_time, 'hh:mm A').set({ year: 1970, month: 0, date: 1 }).utc().toISOString() : null
          })),
          free_wifi: !!this.formData.free_wifi,
          parking: !!this.formData.parking,
          // Process rooms - include existing images but not new File objects
          rooms: this.formData.rooms ? this.formData.rooms.map(room => ({
            ...room,
            images: hasImagesToUpload ? (room.existingImages || []) : (room.images || []),
            // Don't send imagesFiles or existingImages in payload
            imagesFiles: undefined,
            existingImages: undefined
          })) : [],
          room_type_details: this.roomTypesList.map((rt) => ({
            room_type: rt.name,
            description: rt.description,
            number_of_rooms: rt.number_of_rooms
          })),
          is_active: this.formData.is_active !== undefined ? this.formData.is_active : true,
          is_verified: false, // Draft is not verified
          platform_fee: this.formData.platform_fee || 0,
          collect_documents,
          is_documentCollect: this.collectDocumentsEnabled,
          is_draft: true
        }

        // Use FormData if we have images to upload, otherwise use regular payload
        let requestPayload = payload
        let config = {}

        if (hasImagesToUpload) {
          const formData = new FormData()

          // Helper function to append to FormData
          const appendToFormData = (formData, key, value) => {
            if (value === null || value === undefined) {
              return
            }

            if (Array.isArray(value)) {
              formData.append(key, JSON.stringify(value))
            } else if (typeof value === 'object' && !(value instanceof File) && !(value instanceof Date)) {
              formData.append(key, JSON.stringify(value))
            } else {
              formData.append(key, value)
            }
          }

          // Append property images
          if (hasPropertyImages && this.formData.imagesFiles) {
            this.formData.imagesFiles.forEach((file, index) => {
              formData.append('property_images', file)
            })
          }

          // Append room images
          if (hasRoomImages && this.formData.rooms) {
            this.formData.rooms.forEach((room, roomIndex) => {
              if (room.imagesFiles && room.imagesFiles.length > 0) {
                room.imagesFiles.forEach((file, fileIndex) => {
                  formData.append(`room_images_${roomIndex}`, file)
                })
              }
            })
          }

          // Append all other fields to FormData
          Object.keys(payload).forEach(key => {
            appendToFormData(formData, key, payload[key])
          })

          requestPayload = formData
          // Don't set Content-Type header manually - let axios set it automatically with boundary
          config = {}
        }

        const url = this.isEditMode && this.hotelId
          ? `/admin/hotel/${this.hotelId}`
          : '/admin/hotel/create'

        if (this.isEditMode && this.hotelId) {
          await axios.put(url, requestPayload, config)
        } else {
          await axios.post(url, requestPayload, config)
        }

        this.$vs.notify({
          title: 'Success',
          text: `Hotel saved as draft ${this.isEditMode ? 'updated' : 'created'} successfully`,
          color: 'success'
        })

        this.$emit('saved')
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: (error.response && error.response.data && error.response.data.message) || 'Failed to save draft',
          color: 'danger'
        })
      } finally {
        this.hideDraftButtonLoader()
        this.submittingForm = false
        this.isSubmitting = false
        this.isSavingDraft = false
      }
    },
    async handlePublish() {
      // Publish with full validation
      await this.handleFormSubmit()
    },
    async submitForm() {
      // Prevent double submission
      if (this.isSubmitting) {
        return
      }

      this.isSubmitting = true
      this.isPublishing = true
      this.submittingForm = true

      // Attach loader to submit button
      this.$nextTick(() => {
        this.attachLoaderToSubmitButton()
      })

      try {
        // Build collect_documents from documents array
        const collect_documents = this.collectDocumentsEnabled
          ? this.documents.map((doc) => ({
            document_name: doc.name,
            is_required: doc.mandatory,
            description: doc.hint
          }))
          : []

        // Check if we have any File objects to upload (property images or room images)
        const hasPropertyImages = this.formData.imagesFiles && this.formData.imagesFiles.length > 0
        const hasRoomImages = this.formData.rooms && this.formData.rooms.some(room => room.imagesFiles && room.imagesFiles.length > 0
        )
        const hasImagesToUpload = hasPropertyImages || hasRoomImages

        // Build payload - don't include image Files here, they'll be in FormData
        const payload = {
          gurudwara: this.formData.gurudwara,
          property_name: this.formData.property_name,
          description: this.formData.description, // Property description
          // Include existing images (URLs) but not new File objects
          images: hasImagesToUpload ? (this.formData.existingImages || []) : (this.formData.images || []),
          amenities: this.formData.amenities || '', // Payment Terms (confusingly named as amenities in formData)
          hotel_rules: this.formData.hotel_rules || '',
          cancellation_policy: this.formData.cancellation_policy || '',
          safety_information: this.formData.safety_information || '',
          refund_policy: this.formData.refund_policy || '',
          other_name: this.formData.other_name,
          youtube_handle_name: this.formData.youtube_handle_name,
          social_media: this.formData.social_media,
          custom_link: this.formData.custom_link,
          is24hOpen: !!this.formData.is24hOpen,
          opening_hours: this.formData.is24hOpen ? [] : this.formData.opening_hours.map(oh => ({
            day: oh.day,
            open_time: oh.open_time ? moment(oh.open_time, 'hh:mm A').set({ year: 1970, month: 0, date: 1 }).utc().toISOString() : null,
            close_time: oh.close_time ? moment(oh.close_time, 'hh:mm A').set({ year: 1970, month: 0, date: 1 }).utc().toISOString() : null
          })),
          free_wifi: !!this.formData.free_wifi,
          parking: !!this.formData.parking,
          // Process rooms - include existing images but not new File objects
          rooms: this.formData.rooms ? this.formData.rooms.map(room => ({
            ...room,
            images: hasImagesToUpload ? (room.existingImages || []) : (room.images || []),
            // Don't send imagesFiles or existingImages in payload
            imagesFiles: undefined,
            existingImages: undefined
          })) : [],
          room_type_details: this.roomTypesList.map((rt) => ({
            room_type: rt.name,
            description: rt.description,
            number_of_rooms: rt.number_of_rooms
          })),
          is_active: this.formData.is_active !== undefined ? this.formData.is_active : true,
          // Publish should always verify and clear draft state
          is_verified: true,
          is_draft: false,
          platform_fee: this.formData.platform_fee || 0,
          collect_documents,
          is_documentCollect: this.collectDocumentsEnabled
        }

        // Use FormData if we have images to upload, otherwise use regular payload
        let requestPayload = payload
        let config = {}

        if (hasImagesToUpload) {
          const formData = new FormData()

          // Helper function to append to FormData
          const appendToFormData = (formData, key, value) => {
            if (value === null || value === undefined) {
              return
            }

            if (Array.isArray(value)) {
              formData.append(key, JSON.stringify(value))
            } else if (typeof value === 'object' && !(value instanceof File) && !(value instanceof Date)) {
              formData.append(key, JSON.stringify(value))
            } else {
              formData.append(key, value)
            }
          }

          // Append property images
          if (hasPropertyImages && this.formData.imagesFiles) {
            this.formData.imagesFiles.forEach((file, index) => {
              formData.append('property_images', file)
            })
          }

          // Append room images
          if (hasRoomImages && this.formData.rooms) {
            this.formData.rooms.forEach((room, roomIndex) => {
              if (room.imagesFiles && room.imagesFiles.length > 0) {
                room.imagesFiles.forEach((file, fileIndex) => {
                  formData.append(`room_images_${roomIndex}`, file)
                })
              }
            })
          }

          // Append all other fields to FormData
          Object.keys(payload).forEach(key => {
            appendToFormData(formData, key, payload[key])
          })

          requestPayload = formData
          // Don't set Content-Type header manually - let axios set it automatically with boundary
          config = {}
        }

        const url = this.isEditMode && this.hotelId
          ? `/admin/hotel/${this.hotelId}`
          : '/admin/hotel/create'

        if (this.isEditMode && this.hotelId) {
          await axios.put(url, requestPayload, config)
        } else {
          await axios.post(url, requestPayload, config)
        }

        this.$vs.notify({
          title: 'Success',
          text: `Hotel ${this.isEditMode ? 'updated' : 'created'} successfully`,
          color: 'success'
        })

        this.$emit('saved')
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: (error.response && error.response.data && error.response.data.message) || 'Failed to save hotel',
          color: 'danger'
        })
        throw error
      } finally {
        this.hideSubmitButtonLoader()
        this.submittingForm = false
        this.isSubmitting = false
        this.isPublishing = false
      }
    },
    showNextButtonLoader() {
      if (!this.validatingStep) {
        this.validatingStep = true
      }
    },
    hideNextButtonLoader() {
      if (this.validatingStep) {
        this.validatingStep = false
      } else {
        this.hideWizardButtonLoader('next')
      }
    },
    attachLoaderToSubmitButton() {
      const button = document.getElementById('submit-hotel-form-btn')
      if (button && !button.classList.contains('vs-con-loading__container')) {
        button.classList.add('vs-con-loading__container')
        this.$vs.loading({ container: '#submit-hotel-form-btn', scale: 0.45 })
      }
    },
    hideSubmitButtonLoader() {
      const button = document.getElementById('submit-hotel-form-btn')
      if (button) {
        try {
          this.$vs.loading.close('#submit-hotel-form-btn > .con-vs-loading')
        } catch (e) {
          // no-op
        }
        button.classList.remove('vs-con-loading__container')
      }
    },
    attachLoaderToDraftButton() {
      const button = document.getElementById('save-draft-btn')
      if (button && !button.classList.contains('vs-con-loading__container')) {
        button.classList.add('vs-con-loading__container')
      }
      const selector = '#save-draft-btn'
      const existing = document.querySelector(`${selector} .con-vs-loading`)
      if (!existing) {
        this.$vs.loading({ container: selector, scale: 0.45 })
      }
    },
    hideDraftButtonLoader() {
      const button = document.getElementById('save-draft-btn')
      if (!button) return
      try {
        this.$vs.loading.close('#save-draft-btn > .con-vs-loading')
      } catch (e) {
        // no-op
      }
      button.classList.remove('vs-con-loading__container')
    },
    getWizardElement() {
      return this.$refs.formWizard && this.$refs.formWizard.$el
    },
    getWizardButtonConfig(type) {
      if (type === 'finish') {
        return {
          id: 'wizard-finish-btn',
          selectors: [
            '#wizard-finish-btn',
            '.wizard-nav .wizard-btn-finish',
            '.wizard-footer .wizard-btn-finish',
            'button.wizard-btn-finish',
            '.wizard-footer button:last-child',
            '.wizard-buttons button:last-child'
          ],
          textMatches: ['finish', 'submit']
        }
      }
      return {
        id: 'wizard-next-btn',
        selectors: [
          '#wizard-next-btn',
          '.wizard-nav .wizard-btn-next',
          '.wizard-footer .wizard-btn-next',
          'button.wizard-btn-next',
          '.wizard-footer button:last-child',
          '.wizard-buttons button:last-child'
        ],
        textMatches: ['next', 'continue']
      }
    },
    findWizardButton(type) {
      const wizardEl = this.getWizardElement()
      if (!wizardEl) return null
      const config = this.getWizardButtonConfig(type)

      let button = wizardEl.querySelector(`#${config.id}`)
      if (button) return button

      for (const selector of config.selectors) {
        const candidate = wizardEl.querySelector(selector)
        if (candidate) {
          button = candidate
          break
        }
      }

      if (!button) {
        const buttons = wizardEl.querySelectorAll('button')
        button = Array.from(buttons).find((btn) => {
          const text = (btn.textContent || '').toLowerCase()
          return config.textMatches.some((match) => text.includes(match))
        })
      }

      return button || null
    },
    attachLoaderToWizardButton(type) {
      const button = this.findWizardButton(type)
      if (!button) return
      const { id } = this.getWizardButtonConfig(type)
      if (button.id !== id) {
        button.setAttribute('id', id)
      }
      if (!button.classList.contains('vs-con-loading__container')) {
        button.classList.add('vs-con-loading__container')
      }
      const containerSelector = `#${id}`
      const existingLoader = button.querySelector('.con-vs-loading')
      if (!existingLoader) {
        this.$vs.loading({ container: containerSelector, scale: 0.45 })
      }
    },
    clearLoaderRetry(type) {
      const timer = this.loaderRetryTimers[type]
      if (timer) {
        clearTimeout(timer)
        this.loaderRetryTimers[type] = null
      }
    },
    scheduleLoaderRetry(type) {
      this.clearLoaderRetry(type)
      const shouldKeepTrying = () => (type === 'finish' ? this.submittingForm : this.validatingStep)
      if (!shouldKeepTrying()) return
      this.loaderRetryTimers[type] = setTimeout(() => {
        if (shouldKeepTrying()) {
          this.attachLoaderToWizardButton(type)
          this.scheduleLoaderRetry(type)
        }
      }, 120)
    },
    hideWizardButtonLoader(type) {
      this.clearLoaderRetry(type)
      const button = this.findWizardButton(type)
      if (!button) return
      const { id } = this.getWizardButtonConfig(type)
      try {
        this.$vs.loading.close(`#${id} > .con-vs-loading`)
      } catch (e) {
        // no-op
      }
      button.classList.remove('vs-con-loading__container')
    },
    preventBodyScroll() {
      const body = document.body
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
      body.style.overflow = 'hidden'
      body.style.paddingRight = `${scrollbarWidth}px`
      body.classList.add('dropdown-open')
    },
    enableBodyScroll() {
      const body = document.body
      body.style.overflow = ''
      body.style.paddingRight = ''
      body.classList.remove('dropdown-open')
    },
    setupDropdownScrollPrevention() {
      this.$nextTick(() => {
        const wizardEl = this.$el || document
        let observer = null
        let isPreventingScroll = false

        const checkAndPreventScroll = () => {
          // Check for both vs-select and Select2 dropdown options
          const dropdownOptions = wizardEl.querySelectorAll('.vs-select--options, .custom__select .vs-select--options, [class*="vs-select"] .vs-select--options')
          let hasOpenDropdown = false

          dropdownOptions.forEach((option) => {
            const style = window.getComputedStyle(option)
            if (style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0') {
              hasOpenDropdown = true
            }
          })

          if (hasOpenDropdown && !isPreventingScroll) {
            this.preventBodyScroll()
            isPreventingScroll = true
          } else if (!hasOpenDropdown && isPreventingScroll) {
            this.enableBodyScroll()
            isPreventingScroll = false
          }
        }

        // Use MutationObserver to watch for dropdown state changes
        observer = new MutationObserver(() => {
          checkAndPreventScroll()
        })

        observer.observe(wizardEl, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['style', 'class']
        })

        // Also listen for click events on select inputs
        const handleClick = (e) => {
          if (e.target.closest('.vs-select')) {
            setTimeout(checkAndPreventScroll, 50)
          } else {
            setTimeout(checkAndPreventScroll, 100)
          }
        }

        document.addEventListener('click', handleClick, true)

        // Store references for cleanup
        this.dropdownObserver = observer
        this.dropdownClickHandler = handleClick

        // Initial check
        checkAndPreventScroll()
      })
    },
    removeDropdownScrollPrevention() {
      if (this.dropdownObserver) {
        this.dropdownObserver.disconnect()
        this.dropdownObserver = null
      }
      if (this.dropdownClickHandler) {
        document.removeEventListener('click', this.dropdownClickHandler, true)
        this.dropdownClickHandler = null
      }
      this.enableBodyScroll()
    },
    // New Room Management Methods
    openRoomModal(roomType = null) {
      this.currentRoomType = roomType
      if (roomType) {
        // Edit mode - populate form data
        const existingImages = Array.isArray(roomType.images) ? roomType.images : []
        this.roomFormData = {
          name: roomType.name || '',
          number_of_rooms: roomType.number_of_rooms || null,
          room_numbers: roomType.room_numbers || '',
          images: existingImages, // Preview URLs (display)
          imagesFiles: [], // New File objects (will be populated on upload)
          existingImages, // Existing image URLs (for tracking)
          description: roomType.description || '',
          your_charge: roomType.price_per_night || 0,
          net_receive: roomType.net_receive || roomType.received_amount || 0,
          taxes_and_fees: roomType.taxes_and_fees || 0,
          amenities: roomType.amenities || [],
          is_active: roomType.is_active !== undefined ? roomType.is_active : true
        }
        // Restore selected amenities (backend sends snake_case values like "hair_dryer", "conditioner")
        this.$nextTick(() => {
          const selectedAmenityValues = roomType.amenities || []
          this.amenitiesCategories.forEach((category) => {
            category.amenities.forEach((amenity) => {
              // Use value if available (already in snake_case), otherwise convert name to snake_case
              const amenityValue = amenity.value || this.convertToSnakeCase(amenity.name)
              amenity.selected = selectedAmenityValues.includes(amenityValue)
            })
          })
        })
      } else {
        // Add mode - reset form data
        this.roomFormData = {
          name: '',
          number_of_rooms: null,
          room_numbers: '',
          images: [], // Preview URLs for display
          imagesFiles: [], // File objects for FormData upload
          existingImages: [], // Existing image URLs when editing
          description: '',
          your_charge: 0,
          taxes_and_fees: 0,
          amenities: [],
          is_active: true
        }
        // Reset amenities selection
        this.$nextTick(() => {
          this.amenitiesCategories.forEach((category) => {
            category.amenities.forEach((amenity) => {
              amenity.selected = false
            })
          })
        })
      }
      this.roomStep1Errors = {}
      this.roomStep2Errors = {}
      this.roomStep3Errors = {}
      this.currentRoomFormStep = 0
      // Increment key to force wizard re-render and reset to first tab
      this.roomWizardKey++
      this.showRoomModal = true
    },
    toggleRoomOptions(index) {
      this.$set(this.roomTypesList[index], 'showOptions', !this.roomTypesList[index].showOptions)
    },
    duplicateRoomType(roomType) {
      const duplicated = JSON.parse(JSON.stringify(roomType))
      duplicated.name = `${duplicated.name} (Copy)`
      duplicated.showOptions = duplicated.options && duplicated.options.length > 0
      if (duplicated.options) {
        duplicated.options = duplicated.options.map((opt) => ({ ...opt }))
      }
      this.roomTypesList.push(duplicated)
      this.$vs.notify({
        title: 'Success',
        text: 'Room type duplicated successfully',
        color: 'success'
      })
    },
    deleteRoomType(index) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `Are you sure you want to delete "${this.roomTypesList[index].name}"? This action cannot be undone.`,
        accept: () => {
          this.roomTypesList.splice(index, 1)
          this.$vs.notify({
            title: 'Success',
            text: 'Room type deleted successfully',
            color: 'success'
          })
        }
      })
    },
    openOptionModal(roomType, option = null) {
      this.currentRoomTypeForOption = roomType
      this.currentOption = option

      if (option) {
        // Edit mode - populate form data
        this.optionFormData = {
          name: option.name || '',
          capacity: option.capacity || null,
          description: option.description || '',
          your_charge: option.price || 0,
          net_receive: option.received_amount || 0,
          taxes_and_fees: option.taxes_and_fees || 0,
          is_active: option.is_active !== undefined ? option.is_active : true
        }
      } else {
        // Add mode - reset form data
        this.optionFormData = {
          name: '',
          capacity: null,
          description: '',
          your_charge: 0,
          net_receive: 0,
          taxes_and_fees: 0,
          is_active: true
        }
      }

      this.optionStep1Errors = {}
      this.optionStep2Errors = {}
      this.showOptionModal = true
      this.$nextTick(() => {
        if (this.$refs.optionFormWizard) {
          this.$refs.optionFormWizard.activeTabIndex = 0
        }
      })
    },
    getNumberWord(num) {
      const words = ['One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten']
      return words[num - 1] || String(num)
    },
    updateOptionFormStep(prevIndex, nextIndex) {
      this.currentOptionFormStep = typeof nextIndex === 'number' ? nextIndex : this.currentOptionFormStep
    },
    // Add these methods to your component's methods section:

    closeOptionModal() {
      this.showOptionModal = false
      this.currentOption = null
      this.currentRoomTypeForOption = null
      this.optionFormData = {
        name: '',
        capacity: null,
        description: '',
        your_charge: 0,
        net_receive: 0,
        taxes_and_fees: 0,
        is_active: true
      }
      this.optionStep1Errors = {}
      this.optionStep2Errors = {}
    },

    validateOptionForm() {
      // Reset all errors
      this.optionStep1Errors = {}
      this.optionStep2Errors = {}

      let isValid = true

      // Validate Basic Information
      if (!this.optionFormData.name || this.optionFormData.name.trim() === '') {
        this.optionStep1Errors.name = 'Option Name is required'
        isValid = false
      }

      if (!this.optionFormData.capacity || this.optionFormData.capacity < 1 || this.optionFormData.capacity > 10) {
        this.optionStep1Errors.capacity = 'Please select capacity (1-10 people)'
        isValid = false
      }

      if (!this.optionFormData.description || this.optionFormData.description.trim() === '') {
        this.optionStep1Errors.description = 'Option Description is required'
        isValid = false
      }

      // Validate Pricing
      if (!this.optionFormData.your_charge || this.optionFormData.your_charge <= 0) {
        this.optionStep2Errors.your_charge = 'Your Charge is required and must be greater than 0'
        isValid = false
      } else {
        const platformFee = Number(this.calculatedOptionPlatformFee) || 0
        if (this.optionFormData.your_charge < platformFee) {
          this.optionStep2Errors.your_charge = `Your Charge must be at least the Sangat platform fee (₹${platformFee})`
          isValid = false
        }
      }

      return isValid
    },

    async handleSaveOption() {
      // Validate the form
      if (!this.validateOptionForm()) {
        this.$vs.notify({
          title: 'Validation Error',
          text: 'Please fill all required fields correctly',
          color: 'warning'
        })

        // Scroll to first error
        this.$nextTick(() => {
          const firstError = document.querySelector('.option-modal .text-danger')
          if (firstError) {
            firstError.scrollIntoView({ behavior: 'smooth', block: 'center' })
          }
        })
        return
      }

      try {
        if (!this.currentRoomTypeForOption) {
          throw new Error('Room type not found')
        }

        const platformFee = Number(this.calculatedOptionPlatformFee) || 0
        const yourCharge = Number(this.optionFormData.your_charge || 0)
        const receivedAmount = Number(this.optionFormData.net_receive) || Math.max(0, yourCharge - platformFee)

        const optionData = {
          name: this.optionFormData.name,
          capacity: this.optionFormData.capacity,
          description: this.optionFormData.description,
          price: yourCharge,
          your_charge: yourCharge,
          net_receive: receivedAmount,
          taxes_and_fees: platformFee,
          received_amount: receivedAmount,
          is_active: this.optionFormData.is_active
        }

        // Initialize options array if it doesn't exist
        if (!this.currentRoomTypeForOption.options) {
          this.$set(this.currentRoomTypeForOption, 'options', [])
        }

        if (this.currentOption) {
          // Edit mode
          const optionIndex = this.currentRoomTypeForOption.options.findIndex((opt) => opt === this.currentOption)
          if (optionIndex !== -1) {
            this.$set(this.currentRoomTypeForOption.options, optionIndex, optionData)
          }
        } else {
          // Add mode
          this.currentRoomTypeForOption.options.push(optionData)
          // Auto-expand options when adding new one
          this.$set(this.currentRoomTypeForOption, 'showOptions', true)
        }

        this.$vs.notify({
          title: 'Success',
          text: `Option ${this.currentOption ? 'updated' : 'created'} successfully`,
          color: 'success'
        })

        this.closeOptionModal()
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.message || 'Failed to save option',
          color: 'danger'
        })
      }
    },
    validateOptionStep1() {
      return new Promise((resolve, reject) => {
        this.optionStep1Errors = {}
        let isValid = true

        if (!this.optionFormData.name || this.optionFormData.name.trim() === '') {
          this.optionStep1Errors.name = 'Option Name is required'
          isValid = false
        }

        if (!this.optionFormData.capacity || this.optionFormData.capacity < 1 || this.optionFormData.capacity > 10) {
          this.optionStep1Errors.capacity = 'Please select capacity (1-10 people)'
          isValid = false
        }

        if (!this.optionFormData.description || this.optionFormData.description.trim() === '') {
          this.optionStep1Errors.description = 'Option Description is required'
          isValid = false
        }

        setTimeout(() => {
          if (isValid) {
            resolve(true)
          } else {
            reject('Please fill all required fields')
          }
        }, 300)
      })
    },
    validateOptionStep2() {
      return new Promise((resolve, reject) => {
        this.optionStep2Errors = {}
        let isValid = true

        if (!this.optionFormData.your_charge || this.optionFormData.your_charge <= 0) {
          this.optionStep2Errors.your_charge = 'Your Charge is required and must be greater than 0'
          isValid = false
        } else {
          const platformFee = Number(this.calculatedOptionPlatformFee) || 0
          if (this.optionFormData.your_charge < platformFee) {
            this.optionStep2Errors.your_charge = `Your Charge must be at least the Sangat platform fee (₹${platformFee})`
            isValid = false
          }
        }

        setTimeout(() => {
          if (isValid) {
            resolve(true)
          } else {
            reject('Please enter a valid charge amount')
          }
        }, 300)
      })
    },
    saveOption() {
      return new Promise((resolve, reject) => {
        try {
          if (!this.currentRoomTypeForOption) {
            reject(new Error('Room type not found'))
            return
          }

          const platformFee = Number(this.calculatedOptionPlatformFee) || 0
          const yourCharge = Number(this.optionFormData.your_charge || 0)
          const receivedAmount = Number(this.optionFormData.net_receive) || Math.max(0, yourCharge - platformFee)

          const optionData = {
            name: this.optionFormData.name,
            capacity: this.optionFormData.capacity,
            description: this.optionFormData.description,
            price: yourCharge,
            your_charge: yourCharge,
            net_receive: receivedAmount,
            taxes_and_fees: platformFee, // Platform fee
            received_amount: receivedAmount, // Your charge - platform fee
            is_active: this.optionFormData.is_active
          }

          // Initialize options array if it doesn't exist
          if (!this.currentRoomTypeForOption.options) {
            this.$set(this.currentRoomTypeForOption, 'options', [])
          }

          if (this.currentOption) {
            // Edit mode
            const optionIndex = this.currentRoomTypeForOption.options.findIndex((opt) => opt === this.currentOption)
            if (optionIndex !== -1) {
              this.$set(this.currentRoomTypeForOption.options, optionIndex, optionData)
            }
          } else {
            // Add mode
            this.currentRoomTypeForOption.options.push(optionData)
            // Auto-expand options when adding new one
            this.$set(this.currentRoomTypeForOption, 'showOptions', true)
          }

          this.showOptionModal = false
          this.$vs.notify({
            title: 'Success',
            text: `Option ${this.currentOption ? 'updated' : 'created'} successfully`,
            color: 'success'
          })
          resolve(true)
        } catch (error) {
          this.$vs.notify({
            title: 'Error',
            text: error.message || 'Failed to save option',
            color: 'danger'
          })
          reject(error)
        }
      })
    },
    duplicateRoomOption(roomType, option) {
      const roomTypeIndex = this.roomTypesList.findIndex((rt) => rt === roomType)
      if (roomTypeIndex !== -1 && roomType.options) {
        const duplicated = JSON.parse(JSON.stringify(option))
        duplicated.name = `${duplicated.name} (Copy)`
        roomType.options.push(duplicated)
        this.$vs.notify({
          title: 'Success',
          text: 'Option duplicated successfully',
          color: 'success'
        })
      }
    },
    deleteRoomOption(roomType, optionIndex) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `Are you sure you want to delete this option?`,
        accept: () => {
          if (roomType.options) {
            roomType.options.splice(optionIndex, 1)
            this.$vs.notify({
              title: 'Success',
              text: 'Option deleted successfully',
              color: 'success'
            })
          }
        }
      })
    },
    handleRoomTypeFileUpload(event) {
      const files = Array.from(event.target.files)
      const maxFiles = 20
      const maxFileSize = 1 * 1024 * 1024 // 1 MB
      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png']

      if (this.roomStep1Errors.images) {
        this.roomStep1Errors.images = ''
      }

      // Initialize arrays if needed
      if (!this.roomFormData.images) {
        this.roomFormData.images = []
      }
      if (!this.roomFormData.imagesFiles) {
        this.roomFormData.imagesFiles = []
      }
      if (!this.roomFormData.existingImages) {
        this.roomFormData.existingImages = []
      }

      // Check total count (existing images + existing files + new files)
      const existingCount = this.roomFormData.existingImages ? this.roomFormData.existingImages.length : 0
      const currentFileCount = this.roomFormData.imagesFiles ? this.roomFormData.imagesFiles.length : 0
      const currentCount = existingCount + currentFileCount

      if (currentCount + files.length > maxFiles) {
        this.roomStep1Errors.images = `Maximum ${maxFiles} images allowed. You can only upload ${maxFiles - currentCount} more image(s).`
        this.roomTypeFileKey++
        return
      }

      const invalidFiles = []
      const validFiles = []

      files.forEach((file) => {
        if (!allowedTypes.includes(file.type)) {
          invalidFiles.push(`${file.name} - Invalid format. Only PNG and JPG are supported.`)
          return
        }
        if (file.size > maxFileSize) {
          invalidFiles.push(`${file.name} - File size exceeds 1 MB.`)
          return
        }

        // Valid file - store File object and create preview
        validFiles.push(file)

        // Create preview for display
        const reader = new FileReader()
        reader.onload = (e) => {
          this.roomFormData.images.push(e.target.result)
        }
        reader.readAsDataURL(file)
      })

      // Add valid File objects to imagesFiles array
      this.roomFormData.imagesFiles.push(...validFiles)

      if (invalidFiles.length > 0) {
        this.roomStep1Errors.images = invalidFiles.join(' ')
        this.$vs.notify({
          title: 'Upload Error',
          text: 'Some files were not uploaded. Please check the requirements.',
          color: 'warning'
        })
      }

      this.roomTypeFileKey++
    },
    removeRoomTypeImage(index) {
      // Remove from preview array
      this.roomFormData.images.splice(index, 1)

      // Calculate if we're removing an existing image or a new file
      const existingCount = this.roomFormData.existingImages ? this.roomFormData.existingImages.length : 0

      if (index < existingCount) {
        // Removing an existing image
        this.roomFormData.existingImages.splice(index, 1)
      } else {
        // Removing a new file - adjust index to account for existing images
        const fileIndex = index - existingCount
        if (this.roomFormData.imagesFiles && fileIndex >= 0 && fileIndex < this.roomFormData.imagesFiles.length) {
          this.roomFormData.imagesFiles.splice(fileIndex, 1)
        }
      }

      // Clear error if images exist after removal
      const totalImages = (this.roomFormData.existingImages ? this.roomFormData.existingImages.length : 0) +
        (this.roomFormData.imagesFiles ? this.roomFormData.imagesFiles.length : 0)
      if (totalImages > 0 && this.roomStep1Errors.images) {
        this.roomStep1Errors.images = ''
      }
      this.roomTypeFileKey++
    },
    updateRoomFormStep(prevIndex, nextIndex) {
      this.currentRoomFormStep = typeof nextIndex === 'number' ? nextIndex : this.currentRoomFormStep
    },
    getExpectedRoomNumbers() {
      if (!this.roomFormData.number_of_rooms) {
        return ''
      }
      const numRooms = Number(this.roomFormData.number_of_rooms)
      if (numRooms < 1) {
        return ''
      }
      const roomNumbers = []
      for (let i = 1; i <= numRooms; i++) {
        roomNumbers.push(100 + i)
      }
      return roomNumbers.join(',')
    },
    getCustomNamesExample() {
      if (!this.roomFormData.number_of_rooms) {
        return ''
      }
      const numRooms = Number(this.roomFormData.number_of_rooms)
      if (numRooms < 1) {
        return ''
      }
      const customNames = []
      for (let i = 1; i <= numRooms; i++) {
        customNames.push(`room${i}`)
      }
      return customNames.join(', ')
    },
    validateRoomNumbers() {
      // Clear error first
      this.roomStep1Errors.room_numbers = ''

      // If number of rooms is not set, skip validation
      if (!this.roomFormData.number_of_rooms) {
        return
      }

      // If room numbers is empty, skip validation (will be caught in validateRoomStep1)
      if (!this.roomFormData.room_numbers || this.roomFormData.room_numbers.trim() === '') {
        return
      }

      const numRooms = Number(this.roomFormData.number_of_rooms)
      const enteredNumbers = this.roomFormData.room_numbers.trim()

      // Split by comma and filter out empty strings
      const roomNumbersList = enteredNumbers
        .split(',')
        .map((n) => n.trim())
        .filter((n) => n)

      // Check if count matches
      if (roomNumbersList.length !== numRooms) {
        const expectedNumbers = this.getExpectedRoomNumbers()
        this.roomStep1Errors.room_numbers = `You must enter exactly ${numRooms} room number(s) or name(s). Expected format: ${expectedNumbers}`

      }

      // If count matches, it's valid (can be numeric or custom names)
    },
    validateRoomStep1() {
      return new Promise((resolve, reject) => {
        this.roomStep1Errors = {}
        let isValid = true

        if (!this.roomFormData.name || this.roomFormData.name.trim() === '') {
          this.roomStep1Errors.name = 'Room Type Name is required'
          isValid = false
        }

        if (!this.roomFormData.number_of_rooms) {
          this.roomStep1Errors.number_of_rooms = 'Number Of Rooms is required'
          isValid = false
        }

        if (!this.roomFormData.room_numbers || this.roomFormData.room_numbers.trim() === '') {
          this.roomStep1Errors.room_numbers = 'Room numbers or names is required'
          isValid = false
        } else if (this.roomFormData.number_of_rooms) {
          // Validate room numbers count matches the number of rooms
          const numRooms = Number(this.roomFormData.number_of_rooms)
          const enteredNumbers = this.roomFormData.room_numbers.trim()

          // Split by comma and filter out empty strings
          const roomNumbersList = enteredNumbers
            .split(',')
            .map((n) => n.trim())
            .filter((n) => n)

          // Check if count matches
          if (roomNumbersList.length !== numRooms) {
            const expectedNumbers = this.getExpectedRoomNumbers()
            this.roomStep1Errors.room_numbers = `You must enter exactly ${numRooms} room number(s) or name(s). Expected format: ${expectedNumbers}`
            isValid = false
          }
          // If count matches, it's valid (can be numeric or custom names)
        }

        if (!this.roomFormData.images || this.roomFormData.images.length === 0) {
          this.roomStep1Errors.images = 'Room Type Images are required'
          isValid = false
        }

        if (!this.roomFormData.description || this.roomFormData.description.trim() === '') {
          this.roomStep1Errors.description = 'Room Type Description is required'
          isValid = false
        }

        setTimeout(() => {
          if (isValid) {
            resolve(true)
          } else {
            reject('Please fill all required fields')
          }
        }, 300)
      })
    },
    validateRoomStep2() {
      return new Promise((resolve, reject) => {
        // Skip validation if room type has options (pricing step should be hidden)
        if (this.hasRoomTypeOptions) {
          resolve(true)
          return
        }

        this.roomStep2Errors = {}
        let isValid = true

        if (!this.roomFormData.your_charge || this.roomFormData.your_charge <= 0) {
          this.roomStep2Errors.your_charge = 'Your Charge is required and must be greater than 0'
          isValid = false
        } else {
          const platformFee = Number(this.calculatedPlatformFee) || 0
          if (this.roomFormData.your_charge < platformFee) {
            this.roomStep2Errors.your_charge = `Your Charge must be at least the Sangat platform fee (₹${platformFee})`
            isValid = false
          }
        }

        setTimeout(() => {
          if (isValid) {
            resolve(true)
          } else {
            reject('Please enter a valid charge amount')
          }
        }, 300)
      })
    },
    validateRoomStep3() {
      return new Promise((resolve, reject) => {
        // Step 3 validation - amenities are optional, so always pass
        resolve(true)
      })
    },
    saveRoomType() {
      return new Promise((resolve, reject) => {
        try {
          const selectedAmenities = []
          this.amenitiesCategories.forEach((category) => {
            category.amenities.forEach((amenity) => {
              if (amenity.selected) {
                // Use value if available (already in snake_case), otherwise convert name to snake_case
                const amenityValue = amenity.value || this.convertToSnakeCase(amenity.name)
                selectedAmenities.push(amenityValue)
              }
            })
          })

          const platformFee = Number(this.calculatedPlatformFee) || 0
          const yourCharge = Number(this.roomFormData.your_charge || 0)
          const receivedAmount = Number(this.roomFormData.net_receive) || Math.max(0, yourCharge - platformFee)

          // Get existing options or empty array
          const existingOptions = this.currentRoomType && this.currentRoomType.options ? this.currentRoomType.options : []
          const hasOptions = existingOptions && existingOptions.length > 0

          const roomTypeData = {
            name: this.roomFormData.name,
            number_of_rooms: this.roomFormData.number_of_rooms,
            room_numbers: this.roomFormData.room_numbers,
            images: this.roomFormData.images,
            description: this.roomFormData.description,
            // Only include price if room type doesn't have options
            ...(hasOptions
              ? {}
              : {
                price_per_night: yourCharge,
                taxes_and_fees: platformFee, // Platform fee
                received_amount: receivedAmount // Your charge - platform fee
              }),
            amenities: selectedAmenities,
            is_active: this.roomFormData.is_active,
            options: existingOptions,
            showOptions: false
          }

          if (this.currentRoomType) {
            // Edit mode
            const index = this.roomTypesList.findIndex((rt) => rt === this.currentRoomType)
            if (index !== -1) {
              this.$set(this.roomTypesList, index, roomTypeData)
            }
          } else {
            // Add mode
            this.roomTypesList.push(roomTypeData)
          }

          this.showRoomModal = false
          this.$vs.notify({
            title: 'Success',
            text: `Room type ${this.currentRoomType ? 'updated' : 'created'} successfully`,
            color: 'success'
          })
          resolve(true)
        } catch (error) {
          this.$vs.notify({
            title: 'Error',
            text: error.message || 'Failed to save room type',
            color: 'danger'
          })
          reject(error)
        }
      })
    },

    async loadAmenities() {
      this.amenitiesLoading = true
      try {
        const response = await axios.get('/admin/hotel/amenities')
        const categories = response && response.data && response.data.success && Array.isArray(response.data.data)
          ? response.data.data
          : []

        this.amenitiesCategories = categories
          .filter((category) => category && category.is_active !== false)
          .map((category) => ({
            id: category._id,
            name: category.name,
            amenities: (Array.isArray(category.options) ? category.options : [])
              .filter((option) => option && option.is_active !== false)
              .map((option) => ({
                id: option._id,
                name: option.name,
                value: option.value || this.convertToSnakeCase(option.name),
                selected: false
              })),
            expanded: true
          }))
      } catch (error) {
        console.error('Error loading amenities:', error)
        this.amenitiesCategories = []
      } finally {
        this.amenitiesLoading = false
      }
    },
    toggleAmenityCategory(index) {
      this.$set(this.amenitiesCategories[index], 'expanded', !this.amenitiesCategories[index].expanded)
    },
    getSelectedAmenitiesCount(category) {
      return category.amenities.filter((a) => a.selected).length
    },
    convertToSnakeCase(str) {
      if (!str) return ''
      return str
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, '') // Remove special characters
        .replace(/\s+/g, '_') // Replace spaces with underscores
        .replace(/_+/g, '_') // Replace multiple underscores with single
        .replace(/^_|_$/g, '') // Remove leading/trailing underscores
    }
  }
}
</script>

<style scoped>
[dir] .demo-alignment>* {
  margin-top: 0px !important;
}

.text-base {
  font-size: 16px !important;
}

::v-deep .vs-con-textarea h4 {
  font-size: 1rem !important;
}

.remove-image-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.7);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  color: #ffffff;
  transition: background-color 0.2s ease;
}

.remove-image-btn:hover {
  background-color: rgba(0, 0, 0, 0.9);
}

.property-type-card {
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
  border-color: #e5e7eb;
  background-color: #ffffff;
  width: max-content !important;
}

.property-type-card.selected {
  border-color: rgba(var(--vs-primary), 1);
  background-color: rgba(var(--vs-primary), 0.08);
  /* box-shadow: 0 8px 18px rgba(var(--vs-primary), 0.12); */
}

.property-type-checkbox {
  border: 1px solid #d1d5db;
  color: transparent;
}

.property-type-checkbox.selected {
  border-color: rgba(var(--vs-primary), 1);
  background-color: rgba(var(--vs-primary), 1);
  color: #ffffff;
}

.property-type-selected-label {
  color: rgba(var(--vs-primary), 1);
}

/* .hotel-form {
  padding: 4px;
  min-height: 500px;
  background: #fff;
  border-radius: 8px;
   box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); 
} */

.form-header {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e0e0e0;
}

/* .sticky-action-buttons {
  position: sticky;
  top: 0;
  z-index: 1000;
  background: #ffffff;
  padding: 16px 0;
  margin: 0 -20px 24px -20px;
  padding-left: 20px;
  padding-right: 20px;
  border-bottom: 1px solid #e0e0e0;
   box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05); 
  margin-top: -24px;
  margin-bottom: 24px;
} */

/* Hotel Form Wrapper */
.hotel-form-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

/* Hotel Form Container - Creates inner scrolling like vs-table */
.hotel-form-container {
  position: relative;
  width: 100%;
  max-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* Scrollable Form Content */
.form-content-scrollable {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: white;
}

/* Sticky header */
.sticky-action-buttons {
  position: sticky;
  top: 0;
  z-index: 1000;
  background: #ffffff;
  padding: 0px 0px 16px;
  flex-shrink: 0;
}

.form-content {
  padding: 24px;
  min-height: fit-content;
  background-color: white;
}

/* Custom scrollbar */
.form-content-scrollable::-webkit-scrollbar {
  width: 8px;
}

.form-content-scrollable::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.form-content-scrollable::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.form-content-scrollable::-webkit-scrollbar-thumb:hover {
  background: #555;
}

@media (max-width: 1024px) {

  .save-draft-btn,
  .publish-btn {
    width: auto !important;
    padding: 0 40px !important;
  }
}

@media (max-width: 768px) {
  .sticky-buttons-container {
    flex-direction: row;
    gap: 8px;
    align-items: center;
  }

  .sticky-buttons-container>div {
    width: auto;
  }

  .cancel-btn {
    padding: 0 15px !important;
    height: 48px !important;
    font-size: 14px !important;
  }

  .save-draft-btn,
  .publish-btn {
    height: 48px !important;
    padding: 0 15px !important;
    font-size: 14px !important;
    width: auto !important;
    min-width: 100px;
  }

  .form-content {
    padding: 12px;
  }

  .section-title {
    font-size: 20px;
  }
}

@media (max-width: 480px) {
  .sticky-buttons-container {
    padding: 0 8px;
  }

  .property-name-display {
    display: none;
  }
}

.sticky-buttons-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.property-name-display {
  font-size: 16px;
  font-weight: 500;
  color: #374151;
  margin-left: 8px;
}

.cancel-btn {
  font-size: 16px !important;
  border: 1px solid #cccccce5 !important;
  padding: 0px 35px !important;
  height: 60px !important;
  border-radius: 16px !important;
  transition: all 0.2s ease;
}

.save-draft-btn {
  background-color: #f0efee;
  border: 1px solid #f0efee !important;
  border-radius: 18px !important;
  padding: 0px 70px !important;
  height: 60px !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  width: 280px !important;
  color: black;
  transition: all 0.2s ease;
}

.publish-btn {
  background: #000000 !important;
  color: #ffffff !important;
  border-radius: 18px !important;
  padding: 0px 100px !important;
  height: 60px !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  width: 280px;
  transition: all 0.2s ease;
}

.btn-add-option {
  display: flex;
  align-items: center;
  gap: 8px;

  padding: 8px 16px;
  height: 50px;
  margin-bottom: 10px;

  font-size: 15px;
  color: #1e1e1e;
  /* text-gray-600 */
  background-color: #f0efee;

  border: none;
  border-radius: 8px;

  cursor: pointer;
  transition: color 0.2s ease;
}

.add-room-fixed-btn-main {
  display: flex;
  align-items: center !important;
  gap: 18px;

  padding: 8px 24px !important;
  height: 50px !important;
  margin-bottom: 10px !important;
  font-weight: 500;

  font-size: 15px !important;
  color: #1e1e1e !important;
  /* text-gray-600 */
  background-color: #f0efee !important;

  border: none;
  border-radius: 8px;

  cursor: pointer;
  transition: color 0.2s ease;
}

.add-room-fixed-btn-main:hover {
  box-shadow: none !important;
  border: none !important;
  border-radius: 8px !important;
  cursor: pointer !important;
  transition: color 0.2s ease !important;
  color: black !important;
}

/* .add-room-fixed-btn-main .vs-button__content,
.add-room-fixed-btn-main:hover .vs-button__content {
  color: #1E1E1E !important;
}


.add-room-fixed-btn-main svg,
.add-room-fixed-btn-main:hover svg {
  stroke: #1E1E1E !important;
  fill: none !important;
}  */

/* .add-room-fixed-btn-main .vs-button__content {
  color: inherit !important;
} */

.publish-btn:hover {
  background: #1f2937 !important;
  border-color: #1f2937 !important;
}

.publish-btn:disabled {
  background: #9ca3af !important;
  border-color: #9ca3af !important;
  cursor: not-allowed !important;
}

.form-section {
  margin-bottom: 40px;
  border-bottom: 3px solid #cccccce5;
  padding-bottom: 30px;
}

.section-title {
  font-size: 26px;
  font-weight: 700;
  color: black;
  margin-bottom: 20px;
  padding-bottom: 12px;
}

.hotel-form>>>.room-list-label {
  font-size: 16px !important;
}

.hotel-form>>>.add-room-fixed-btn,
.hotel-form>>>.add-room-fixed-btn .vs-button__text,
.hotel-form>>>.add-room-fixed-btn .vs-button-text {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
}

.hotel-form>>>.wizard-progress-with-circle {
  z-index: 1 !important;
}

.hotel-form>>>.wizard-icon-circle {
  z-index: 1 !important;
}

/* .room-management-container {
  max-height: 70vh;
  overflow-y: auto;
  padding-right: 10px;
  padding-bottom: 20px;
}

.room-management-container::-webkit-scrollbar {
  width: 8px;
}

.room-management-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.room-management-container::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.room-management-container::-webkit-scrollbar-thumb:hover {
  background: #555;
} */

.rooms-list {
  position: relative;
}

.room-item-wrapper {
  position: relative;
  margin-bottom: 20px;
}

.room-item-wrapper:not(:last-child)::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 0;
  right: 0;
  height: 2px;
  /* background: linear-gradient(to right, transparent, #e0e0e0, transparent); */
}

.room-item {
  position: relative;
  transition: all 0.3s ease;
  background: #fff;
  border: 1px solid #e0e0e0;
}

.room-item:hover {
  background: #f8f9fa;
  border-color: #1976d2;
}

.room-number-badge {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #1976d2;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 14px;
  flex-shrink: 0;
}

/* Form wizard styling improvements */
.hotel-form>>>.wizard-header {
  padding: 20px 30px 15px 30px;
  background: #f8f9fa;
  margin: 0;
}

.hotel-form>>>.wizard-tab-content {
  padding: 30px;
  padding-top: 0px;
  min-height: 500px;
  max-height: calc(100vh - 350px);
  overflow-y: auto;
  overflow-x: hidden;
  background: #fff;
  position: relative;
}

.hotel-form>>>.wizard-footer {
  padding: 20px 30px;
  background: #f8f9fa;
  border-top: 1px solid #e0e0e0;
  position: sticky;
  bottom: 0;
  z-index: 10;
  margin: 0;
}

.hotel-form>>>.wizard-nav {
  background: #fff;
  padding: 0 30px;
}

.hotel-form>>>.wizard-nav-item {
  padding: 15px 20px;
}

/* Fixed Add Room Button - Top of Rooms Tab */
.fixed-add-room-btn-top {
  position: sticky;
  top: 0;
  z-index: 100;
  background: #ffffff;
  padding: 15px 0;
  margin-bottom: 20px;
  padding-top: 45px;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  min-height: 60px;
}

.add-room-fixed-btn {
  padding: 14px 28px !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
}

.add-room-fixed-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

.add-room-fixed-btn:active {
  transform: translateY(0);
}

/* Add padding to room container */
.room-management-container {
  padding-top: 10px;
}

/* Prevent body scroll when dropdown is open - backup CSS */
body.dropdown-open {
  overflow: hidden !important;
}

/* Ensure dropdown options are scrollable even when body scroll is disabled */
.hotel-form>>>.vs-select--options {
  max-height: 300px;
  overflow-y: auto !important;
  overflow-x: hidden;
}

/* File Upload Styles - New Design */
.file-upload-wrapper {
  margin-bottom: 12px;
}

.file-upload-box {
  display: block;
  width: 100%;
  max-width: 400px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 24px 28px;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: #ffffff;
}

.file-upload-box:hover {
  border-color: #9ca3af;
  background-color: #f9fafb;
}

.file-input-hidden {
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
  overflow: hidden;
  z-index: -1;
}

.file-upload-content-new {
  display: flex;
  align-items: center;
  gap: 12px;
}

.file-upload-text-new {
  font-size: 16px;
  color: #000000;
  font-weight: 500;
}

.file-upload-note {
  background-color: #fef3c7;
  border-radius: 4px;
  padding: 2px 6px;
  margin-top: 12px;
  max-width: 100%;
}

.file-upload-note-text {
  font-size: 14px;
  color: #92400e;
  margin: 0;
  line-height: 1.5;
}

/* Room Type List Styles */
.room-type-item {
  margin-bottom: 16px;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
}

.room-type-header {
  transition: all 0.3s ease;
  border-radius: 10px;
  overflow: hidden;
}

/* .room-type-header:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
} */

.room-options-container {
  margin-top: 8px;
  transition: all 0.3s ease;
}

.room-option-item {
  transition: all 0.2s ease;
  border: 1px solid black;
  border-radius: 10px;
  padding: 10px;
}

.room-option-item:hover {
  background-color: #f9fafb;
}

/* Slide fade transition for expandable options */
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s ease-in;
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

/* Amenity Category Styles */
.amenity-category {
  transition: all 0.2s ease;
}

.amenity-category:hover {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.amenity-items {
  padding-top: 12px;
}

/* Room Type Modal Styles */
.room-type-modal>>>.vs-popup {
  max-width: 1200px;
  width: 95%;
}

.room-type-modal>>>.wizard-tab-content {
  max-height: 600px;
  overflow-y: auto;
}

/* Option Modal Styles */
.option-modal>>>.vs-popup {
  max-width: 800px;
  width: 95%;
}

.option-modal-header {
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 15px;
  margin-bottom: 20px;
}

.capacity-toggle-item {
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
}

.capacity-toggle-item:hover {
  border-color: rgba(var(--vs-primary), 1);
  background-color: rgba(var(--vs-primary), 0.05);
}

.capacity-toggle-item.selected {
  border-color: rgba(var(--vs-primary), 1);
  background-color: rgba(var(--vs-primary), 0.1);
  box-shadow: 0 2px 4px rgba(var(--vs-primary), 0.2);
}

.capacity-toggle-item>>>.vs-switch {
  margin: 0;
}

/* Modal Wrapper Styles - Standard Structure with Sticky Buttons */

/* Sticky Action Buttons at Top */
.modal-sticky-buttons {
  position: sticky;
  top: 0;
  z-index: 1000;
  background: #ffffff;
  padding: 16px 24px;
  border-bottom: 1px solid #e5e7eb;
}

/* Scrollable Content Area */
.modal-scroll-content {
  max-height: calc(80vh - 120px);
  overflow-y: auto;
  overflow-x: hidden;
}

/* Custom scrollbar for modal content */
.modal-scroll-content::-webkit-scrollbar {
  width: 8px;
}

.modal-scroll-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.modal-scroll-content::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.modal-scroll-content::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Remove default popup padding */
.room-type-modal>>>.vs-popup,
.option-modal>>>.vs-popup {
  padding: 0 !important;
}

.room-type-modal>>>.vs-popup--content,
.option-modal>>>.vs-popup--content {
  padding: 0 !important;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .modal-sticky-buttons {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
  }

  .modal-sticky-buttons .property-name-display {
    display: none;
  }

  .modal-sticky-buttons .flex {
    width: 100%;
    justify-content: flex-end;
  }

  .modal-sticky-buttons vs-button {
    flex: 1;
    max-width: 120px;
  }

  .modal-scroll-content {
    max-height: calc(95vh - 100px);
  }
}

/* Tooltip Styles */
.tooltip-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.tooltip-text {
  visibility: hidden;
  opacity: 0;
  background-color: #1f2937;
  color: #ffffff;
  text-align: center;
  border-radius: 6px;
  padding: 8px 12px;
  position: absolute;
  z-index: 1000;
  bottom: 125%;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  font-size: 13px;
  font-weight: 500;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: opacity 0.3s ease, visibility 0.3s ease;
  pointer-events: none;
}

.tooltip-text::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #1f2937 transparent transparent transparent;
}

.tooltip-wrapper:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}

/* For better positioning on smaller screens */
@media (max-width: 768px) {
  .tooltip-text {
    white-space: normal;
    max-width: 250px;
    white-space: normal;
    word-wrap: break-word;
  }
}

/* Room Management Classes */
.room-type-title {
  font-size: 18px;
  font-weight: 700;
  color: black;
  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.room-edit-link {
  color: #0b1444;
  cursor: pointer;
  font-weight: 600;
  font-size: 18px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.room-edit-link:hover {
  text-decoration: underline;
}

.room-item-description {
  font-weight: 500;
  max-width: 180px;
  color: #666666;
  font-size: 14px;
  margin-top: 0.25rem;
}

.room-action-link {
  color: #0b1444;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  white-space: nowrap;
}

.room-action-link:hover {
  text-decoration: underline;
}

.room-price-display {
  color: #0b1444;
  white-space: nowrap;
  font-weight: 500;
  font-size: 18px;
}

.room-taxes-display {
  font-weight: 500;
  max-width: 180px;
  color: #666666;
  font-size: 14px;
}

.room-type-header {
  transition: all 0.3s ease;
  overflow: hidden;

}

.room-option-title {
  font-size: 18px;
  font-weight: 600;
  color: #0b1444;
}

.room-capacity-more {
  font-size: 12px;
  font-weight: 700;
  align-self: center;
}

.room-option-details-container {
  color: #0b1444;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.room-section-title {
  font-size: 26px;
  font-weight: 700;
  color: black;
}

.room-add-icon {
  font-size: 24px;
  line-height: 20px;
  font-weight: 500;
}

@media (max-width: 1400px) {
  .room-section-title {
    font-size: 22px;
  }

  .room-type-title,
  .room-edit-link,
  .room-option-title {
    font-size: 16px;
  }

  .room-action-link,
  .room-item-description,
  .room-taxes-display,
  .room-option-details-container {
    font-size: 13px;
  }

  .room-price-display {
    font-size: 16px;
  }

  .room-options-container {
    margin-left: 1rem !important;
  }
}
</style>
